/**
 * @title header.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the header component.
 * @dependency utility.js
 */
define(['zipCodeModal', 'ajaxmodular', 'nav_v2', 'tooltip', 'retainSearchTerm'], function(zipCodeModal, ajaxModular, nav_v2, tooltip, retainSearchTerm) {
  let Header = {
    miniBannerRefreshAjax : true,
    itemPartNumberSelcted: '',
    narvarDCFetchedSku: '',
    kmsiCount : 0,

	/**
     * The initializing function modules use
     * to call.
     * @return {void}
     */
    init: function() {
    	try{
    	nav_v2.init();
    	if (sessionStorage.getItem("landingPage") === null ) {
    	    sessionStorage.setItem("landingPage", JSON.stringify({
    	        referrer: document.referrer,
    	        href: window.location.href,
    	        search: window.location.search
    	    }) );
    	}
        if (window.location.href.includes("referralId") ) {
	        var landingUrl = window.location.href;
	    	var pathname = landingUrl.split('?')[1];
	    	var referalId = pathname.split('=')[1]
	    	sessionStorage.setItem("membershipReferalId",referalId );
        }
    	COSTCO.util.safe(this.kmsi());
      COSTCO.util.safe(this.changeLinksForQuickPurchase)();
      COSTCO.util.safe(this.setup_popovers)();
      COSTCO.util.safe(this.prevent_drop_dragovers)();
      COSTCO.util.safe(this.replaceShopMembershipLinksOnAddToCart)();
      COSTCO.util.safe(this.searchFieldValidation)();

      COSTCO.util.safe(this.signInOutContainerInit)();
      COSTCO.util.safe(this.miniShopCartRefresh)();
      COSTCO.util.safe(this.showBanner)();
      COSTCO.util.safe(this.setupSearchDropdown)();
      // This is moving to global.js.initOnLoad to prevent the dropdowns
      // from being invoked before the document.readyState = complete
      // COSTCO.util.safe(this.setup_nav_dropdown)();
      COSTCO.util.safe(this.resetSearch)();
      COSTCO.util.safe(this.closeAlertBanner)();
      COSTCO.util.safe(this.hideGroceryBannerForInvalidRegion)();
      //Depot Catalog Online - Required only if grocery flow and if DepotCatalogOnline enabled.
      if(COSTCO.util.islocationControlledInventoryFlow() && COSTCO.util.isDepotCatalogEnabled()){
    	  COSTCO.util.safe(this.bindRefreshBtn)();
	  }

      // header.js Initialization

	  let suggestionEnabled = $('#typeAheadEnabled').val();

	  let lwTypeAheadEnabled = COSTCO.LWSearch.isLWTypeAheadEnabled();

      if(suggestionEnabled === 'true' && !lwTypeAheadEnabled){
    	  COSTCO.util.safe(this.typeahead)();
      }

      COSTCO.util.display_SelectOrSignInButton();

      // Align all add to cart button in same line
      let waitForFinalEvent = (function() {
        let timers = {};
        return function(callback, ms, uniqueId) {
          if (!uniqueId) {
            uniqueId = '###';
          }
          if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
          }
          timers[uniqueId] = setTimeout(callback, ms);
        };
	  })();

      // this will align quick buy buttons when user switches view.
      $(window).resize(function() {
        waitForFinalEvent(function() {
          Header.align_quickbuy_btn();
        }, 500, '###');
      });
      this.popovers();
      var appType = $('#applicationType').val();
      if (appType == 'BD'){
    	  COSTCO.zipCodeModal.init();
      }
      $('#logoff').click(function(){$.cookie('C_GOP', null, {path:'/'}); return false;});

      /**
       * Below code handles the onclick events on  User Account Menu
       * React Top Flyout Nav Bar component
       */
      let memberCookie = COSTCO.util.getMemberCookie();
      let c = $.cookie('hashedUserId');
      if (c != null && c!= undefined && c != "") {
      	  $('#myaccount-react-m, #myaccount-react-t').attr('href', 'javascript:void(0);');

	      $('#myaccount-react-d,#myaccount-react-m,#myaccount-react-t').click(function (){

	    	  let queryToMatch = '(min-width: 1025px)';  // 1024px is a tablet

	    	  // This will return a boolean true for desktop and false for tablets and phones.
	    	  if(window.matchMedia(queryToMatch).matches){
		    	  window.wioEventBus.publish('accountMenu', { accountMenu: true });
	    	  }else{
            	  window.location.href = '/AccountHomeView';
	    	  }
	       });
      }

      // populate selectedItem property for nav bar react component lists option highlighting
      $('#miniBannerList,#miniBannerListBD').click(() => {
    	  COSTCO.Global.updateSelectedMenuItem('Lists.label');
      });

      // populate selectedMenuItem in session storage nav bar react component RenewMembership option to be highlighted
      if(window.location.href.includes("RenewMembershipView")){
    	  COSTCO.Global.updateSelectedMenuItem("Renew.label");
      }

      if (this.hasInvPostalCodeCookie() && this.isInvCityStateCookieMissing()) {
    	  if ($('#isGeocodeService').val() != "true") {
    		  COSTCO.util.callBingAndUpdateCookies($.cookie('invCheckPostalCode'));
    	  } else {
    		  COSTCO.util.callGeocodeAPIAndUpdateCookies($.cookie('invCheckPostalCode'));
    	  }
      }
      if(window.location.href.includes("AccountHomeView")){
    	  COSTCO.Global.updateSelectedMenuItem("AccountHome.label");
      }
      // populate selectedMenuItem in session storage to display Account Home as page title
      if(window.location.href.includes("AccountHomeView")){
    	  COSTCO.Global.updateSelectedMenuItem("AccountHome.label");
      }
    	}catch(e){
    		console.error("Header Js error" + e);
    	}
     // COSTCO.util.safe(this.kmsi());
      COSTCO.util.safe(this.hidePrimaryClause)();
      retainSearchTerm.init();

    },

    /**
     * Checks if inv cookie values for state and zip are missing
     */
    isInvCityStateCookieMissing: function() {
      return $.cookie('invCheckCity') == null || $.cookie('invCheckStateCode') == null || $.cookie('invCheckCity') == '' || $.cookie('invCheckStateCode') == '';
    },

    /**
     * Checks if inv cookie values for state and zip are missing
     */
    isInvStateCookieMissing: function() {
      return  $.cookie('invCheckStateCode') == null || $.cookie('invCheckStateCode') == '';
    },

    /**
     * Checks in inv zipcode cookie is present
     */
    hasInvPostalCodeCookie: function() {
      return $.cookie('invCheckPostalCode') != null;
    },

    /**
     * Function used to link the hidden dropdown for search widget
     * We need to attach 2 event
     *    1. Onchange event on the select dropdown which will update the search dropdown facade and the input field
     *    2. Onfocus event which will then style the facade to be in focus
     */
    setupSearchDropdown: function() {
    	$('#search-dropdown-select').change(function (event) {
    		let selectedCat = $( "#search-dropdown-select option:selected").first();
    		let catFacadeTxt = selectedCat.data('disp-facade');
    		let catValue = '/'+selectedCat.val();

    		//Set facade text to the catFacadeTxt
    		$('#search-label').text(catFacadeTxt);
    		$('#formcatsearch').attr('action', catValue);
    		$('#selected-type').val(catFacadeTxt);
    	});
    	$('#search-dropdown-select').focus(function (event) {
    		$('#search-dropdown-facade').addClass('focus');
    	});
    	$('#search-dropdown-select').blur(function (event) {
    		$('#search-dropdown-facade').removeClass('focus');
    	});

    },
    /**
     * Tool tips.
     */
    popovers: function() {
      $('.minibanner-help').popover({
        trigger: 'focus',
        placement: 'bottom',
	  });
	  $('.a11y-tooltip').on('shown.bs.popover', function() {
          $(this).attr('aria-expanded', 'true');
      })
      .on('hidden.bs.popover', function() {
        $(this).attr('aria-expanded', 'false');
      });
      $('.help-icon, .a11y-tooltip, .co-help').popover();

      $('.a11y-tooltip').on('click', function(event) {
    	  event.preventDefault();
      });
    },
    checkIsGroceryVisited: function() {
    	let isGroceryVisited = sessionStorage.getItem('isGroceryVisited');
    	if(null==isGroceryVisited || $.isEmptyObject('isGroceryVisited') || !isGroceryVisited || isGroceryVisited == "false"){
    		return false;
    	}else{
    		return true;
    	}
    },
    checkIsRestricted: function() {
    	let isRestrictedPostalCode = localStorage.getItem('isRestrictedPostalCode');
    	if(null == isRestrictedPostalCode || $.isEmptyObject('isRestrictedPostalCode') || !isRestrictedPostalCode || isRestrictedPostalCode == 'false'){
    		return false;
    	}else{
    		return true;
    	}
    },
    /**
     * Function that verifies whether the Grocery Modal has been displayed and only allows a
     * once per session pop-up
     */
    checkIsGroceryModalDisplayed: function() {
    	let isGroceryModalDisplayed = sessionStorage.getItem('isGroceryModalDisplayed');
    	if(null==isGroceryModalDisplayed || $.isEmptyObject('isGroceryModalDisplayed') || !isGroceryModalDisplayed || isGroceryModalDisplayed == "false"){
    		return false;
    	}else{
    		return true;
    	}
    },

    /**
     * Function that verifies whether the Zip Code Cookie was set by Akamai
     */
    checkIsZipSetByAkamai: function() {
    	let isZipSetByAkamai = sessionStorage.getItem('isZipSetByAkamai');
    	if(null==isZipSetByAkamai || $.isEmptyObject('isZipSetByAkamai') || !isZipSetByAkamai || isZipSetByAkamai == "false"){
    		return false;
    	}else{
    		return true;
    	}
    },

    /**
     * Function that verifies whether Zip Code is forced-submitted (the flow should not be disrupted, AddressType modal should not be able to close).
     */
    checkIsForcedSubmitZipcode: function() {
      let isForcedSubmitZipcode = sessionStorage.getItem('isForcedSubmitZipcode');
      if (null==isForcedSubmitZipcode || $.isEmptyObject('isForcedSubmitZipcode') || !isForcedSubmitZipcode || isForcedSubmitZipcode == "false") {
        return false;
      } else {
        return true;
      }
    },


    /**
     * AJAX call to invoke AjaxDistributionCenterRetrievalCmd() to retrieve the closest distribution center
     */
    updateDistributionCenter : function(zipCode, state, item, callBack) {
		COSTCO.util.ajax({
	        url: '/AjaxDistributionCenterRetrievalCmd',
	        type: 'POST',
	        dataType: 'json',
	        data: {
	        	destinationZip: zipCode,
	        	destinationState: state,
	        	item: item,
	        },
	        done: (data) => {callBack(data)},
	        fail: (data) => {
	        	console.error('AjaxDistributionCenterRetrievalCmd ajax call fail for zip code: '+ zipCode);
	        }
	      });
    },

    /**
     * AJAX call to invoke AjaxShipModeRetrievalCmd() to retrieve the closest distribution center
     */
    updateNarvarShipCode : function(item, callBack) {
		COSTCO.util.ajax({
	        url: '/AjaxShipModeRetrievalCmd',
	        type: 'POST',
	        dataType: 'json',
	        data: {
	        	item: item,
	        },
	        done: (data) => {callBack(data)},
	        fail: (data) => {
	        	console.error('AjaxShipModeRetrievalCmd ajax call fail for item: '+ item);
	        }
	      });
    },

    showEDDWidget: function() {
    	var edd_html = "";
    	let invCheckPostalCode = $.cookie('invCheckPostalCode');
    	let invCheckStateCode = $.cookie('invCheckStateCode');
    	if (typeof(invCheckStateCode) !== 'undefined' && invCheckStateCode != null && invCheckStateCode.length > 2) {
    		invCheckStateCode = invCheckStateCode.substring(2);
    	}
    	let item = COSTCO.Header.itemPartNumberSelcted;
    	let vendor = $('#vendorName').val();
    	let groceryPdt = $('#groceryIdentifier').val();

    	let isPDP = $('#productPage').val();
    	let langId = COSTCO.util.getLangId();
		let regexPattern = COSTCO.util.POSTAL_CODE_REGEX_US;
		if (langId == -24 || langId == -25) {
			regexPattern = COSTCO.util.POSTAL_CODE_REGEX_CA;
		}

    	if (isPDP) {
    		// Show the primary clause by default unless
    		$('.primary-clause').show();

    		// Only execute this if the vendor is narvar
    		if (typeof vendor !== 'undefined' && vendor.toLowerCase().includes('narvar')) {
    			// if the zip code isn't set, display the prompt to have customer set it
    			if(!invCheckPostalCode || !regexPattern.test(invCheckPostalCode.replace(/\+/g,' '))) {
    			 if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
    			   edd_html += COSTCO.util.tmpl('templ_edd_widget_fallback_v2', {});
    			 } else {
    			   edd_html += COSTCO.util.tmpl('templ_edd_widget_fallback', {});
    			 }
   	    		 $('.edd-container').html(edd_html);
   	    		 COSTCO.util.hover_click_popover('#edd-postal-code-link-backup', '#edd-postal-code-popover')
    			} else {

    				if((typeof(groceryPdt) === 'undefined' || groceryPdt == "false") ||(typeof(groceryPdt) !== 'undefined' && groceryPdt == "true"  && (typeof(costcoStoreFeatures.EDD_GROCERY_ENABLED) !== 'undefined' && costcoStoreFeatures.EDD_GROCERY_ENABLED === true))) {
	    				// if zip code does exist, make sure to get an updated distribution center
    					COSTCO.Header.narvarDCFetchedSku = COSTCO.Header.itemPartNumberSelcted;
    					COSTCO.Header.updateDistributionCenter(invCheckPostalCode, invCheckStateCode, item, (data) => {
	     	  				$('.eddData').attr("data-narvar-dc-id", data.distributionCenterId);
	     	  				let eddDistro = "";

		   	        		if (typeof $('.eddData').attr("data-narvar-dc-id") !== 'undefined') {
		   	        			eddDistro = $('.eddData').attr("data-narvar-dc-id");
		   	        			// if the distribution center doesn't exist, don't show any prompt
		   	        			if(typeof eddDistro === 'undefined' || eddDistro === null || eddDistro === '') {
		   	        				if(typeof(groceryPdt) !== 'undefined' && groceryPdt == "true" ){
		   	        			    	edd_html += COSTCO.util.tmpl('templ_edd_widget_grocery_error_v2', {});
		   	        			    } else {
		   	        			    	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
		   	        			    		edd_html += COSTCO.util.tmpl('templ_edd_widget_error_v2', {});
		   	            			    } else {
		   	            			    	edd_html += COSTCO.util.tmpl('templ_edd_widget_error', {});
		   	            			    }
		   	        			 	}
			   	      	    		$('.edd-container').html(edd_html);
			   	      	    		COSTCO.util.hover_click_popover('#edd-postal-code-link-backup', '#edd-postal-code-popover')
		   	            		} else {
		   	            			 // if the distribution center DOES exist, show the EDD widget
		   	            			if(typeof(groceryPdt) !== 'undefined' && groceryPdt == "true"){
	   	            			    	edd_html += COSTCO.util.tmpl('templ_edd_widget_grocery_v2', {});
		   	            			} else {
		   	            				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
		   	            					edd_html += COSTCO.util.tmpl('templ_edd_widget_v2', {});
		   	            			    } else {
		   	            			    	edd_html += COSTCO.util.tmpl('templ_edd_widget', {});
		   	            			    }
		   	            			}
		   		       	    		 $('.edd-container').html(edd_html);
		   		       	    		 COSTCO.util.hover_click_popover('#edd-postal-code-link', '#edd-postal-code-popover');
		   		       	   			 $('.eddData').attr("data-narvar-dest-zip", invCheckPostalCode);
		   		       	   			 $(".eddData").html("");
		   		       	   			 $('#edd-postal-code').html(invCheckPostalCode.replace(/\+/g,' ').toUpperCase());
		   		       	   			 $('#edd-postal-code-popover').popover('disable');
		   		       	   			 $('#edd-postal-code-popover-backup').popover('disable');
		   		       	   			 COSTCO.Header.updateNarvarShipCode(item, (data) => {
		   		       	   				$('.eddData').attr("data-narvar-service-code", data.narvarShipCode);
		   		       	   				COSTCO.Header.startEDDMutationObserver();
		   		       	   			 });
		   		       	   			 $('.primary-clause').hide();
		   	            		}
		   	        		}
	     	  			});
    				}
       			}
    		}
    	}
    },

    /**
     * Function to process location data and verify zip code validity.
     * @param Object location data from Bing callback.
     * @return Object of valid zip code, country and province.
     */
    extractLocationData : function(data) {
    	let invalidZip = false;
    	let province = null;
		let country = null;
    	if ($('#isGeocodeService').val() != "true") {
    		try {
    			//Check out if country is Puerto Rico specific
      			country = data.resourceSets[0].resources[0].address.countryRegionIso2;
    			if (country != undefined && country === 'PR') {
    				province = data.resourceSets[0].resources[0].address.countryRegionIso2;
    				country = 'US';
    			} else {
    				province = data.resourceSets[0].resources[0].address.adminDistrict;
    			}
            } catch (e) {
      		  province = null;
      		  country = null;
            }

      		if(province == null || country == null){
      			invalidZip = true;
      		} else if(wcs.storeId == '10301' && country != 'US') {
      			invalidZip = true;
      		} else if(wcs.storeId == '10302' && country !='CA') {
      			invalidZip = true;
      		}
      		return locationData = {
      			InvalidZip: invalidZip,
      			Province: province,
      			Country: country
      		}
    	}
    	province = data[0].stateProvinceAbbreviation;
    	if (province == null) {
    		province = data[0].stateProvince;
    	}
    	country = data[0].country;
    	if(province == null || country == null){
  			invalidZip = true;
  		} else if(wcs.storeId == '10301' && country != 'USA') {
  			invalidZip = true;
  		} else if(wcs.storeId == '10302' && country !='CAN') {
  			invalidZip = true;
  		}
  		return locationData = {
  			InvalidZip: invalidZip,
  			Province: province,
  			Country: country
  		}
    },

    /**
     * Function to set delivery/grocery cookies
     * (70*3600*365 seconds) which equals 1064.5 days
     */
    setDeliveryCookies : function(zipCode, province, country) {
		$.cookie('invCheckStateCode', province, {path: "/", expires: 1064});
		$.cookie('invCheckPostalCode', zipCode, {path: "/", expires: 1064});
		COSTCO.Header.updateGroceryShipPostalCodeDisplay();
    },

    isValidZipCode : function(element) {
    	$.validator.addMethod("countrySpecificZipcode",
    			function(value, element) {
    				if(wcs.storeId === '10301')
    					return (COSTCO.util.POSTAL_CODE_REGEX_US).test($.trim(value));
    				if(wcs.storeId === '10302')
    					return (COSTCO.util.POSTAL_CODE_REGEX_CA).test($.trim(value));
    			},
    			messages.ERR_GROCERY_INVALID_ZIP);

    	$(element).validate({
	  		debug: true,
  			rules: {
	  			deliveryPostalCode: {required: true, countrySpecificZipcode:true}
			},
			messages: {
				deliveryPostalCode : messages.ERR_GROCERY_INVALID_ZIP
			},
			errorPlacement: function($error, $element) {
	          let errorContainer = $(element).find('div.error');
	          errorContainer.empty();
	          errorContainer.append($error);
	        },
	        invalidHandler: function(event, validator) {
	          validator.errorList[0].element.focus();
	        },
	        highlight: COSTCO.util.highlightWithErrorLabel,
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
		});

        return $(element).valid();
    },

    validateUpdateZipCode : function(element) {
    	let errorContainer = $(element).find('div.error');
   	 	event.preventDefault();
   	 	$('div.error').empty();
   	 	let form = event.currentTarget;
    	if (COSTCO.Header.isValidZipCode(element)) {
    		if(typeof document.getElementById("isEDDNarvarFlow") !== "undefined" && document.getElementById("isEDDNarvarFlow") !== null)
			{
	  	  		document.getElementById("isEDDNarvarFlow").value=true;
			}
    		let deliveryFormZipCode =null;
	  	  	if(wcs.storeId === '10302')
	  	  		{
	  	  			if($('#edd-zip-code-field') !== undefined && $('#edd-zip-code-field') !== null)
	  	  				{
	  	  					 deliveryFormZipCode = $('#edd-zip-code-field').val();
	  	  				}
	  	  		}
	  	  	else
	  	  		{
	  	  			 deliveryFormZipCode  = $(form).find("input[name=deliveryPostalCode]").val();
	  	  		}

	  	  	window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
    	}

    },

    validateEddZipCode : function(element) {
		if (COSTCO.Header.isValidZipCode(element)) {
	    	let updateGroceryCookies = function(data, textstatus, XMLHttpRequest) {
	    		let errorContainer = $(element).find('div.error');
				if(errorContainer) {
					errorContainer.empty();
				}

				let locationData = COSTCO.Header.extractLocationData(data);
				let invalidZip = locationData.InvalidZip;
		    	let province = locationData.Province;
				let country = locationData.Country;

	  	  		if(invalidZip) {
	  	  			if(errorContainer) {
	  	  				errorContainer.append(messages.ERR_INVALID_ZIP_EDD);
	  	  			}
	  	  			let inputContainer = $(element).find('.form-control');
	  	  			if(inputContainer){
	  	  				inputContainer.attr('aria-invalid','true');
	  	  				inputContainer.addClass("error");
	  	  			}
	    		 } else {
	  	  			COSTCO.Header.setDeliveryCookies(newZip, province, country);
	  	  			COSTCO.Header.showEDDWidget();
	  	  		 }
	    	};
	    	let newZip = $('#edd-zip-code-field').val();
	    	let isGeocodeService = $('#isGeocodeService').val() == "true";
    		if (newZip !== null && !isGeocodeService) {
    			COSTCO.util.callBing(newZip, updateGroceryCookies, updateGroceryCookies);

    		 } else {
    			 COSTCO.util.callGeocodeAPI(newZip, updateGroceryCookies, updateGroceryCookies);
    		 }

    	}
    },

    /**
     * Function to validate delivery zip code
     * 2 validation will be done
     * 	 1. Standard form validation postal regex and required
     *   2. Pass the zipcode to bing to also lookup country and state
     *   	which we will pass to the command to valid zipcode
     */
    validateDeliveryZipCode: function(element){
  	  	if (COSTCO.Header.isValidZipCode(element)) {
  	  		let updateDeliveryStateCountry = function(data) {
	  	  		let errorContainer = $(element).find('div.error');
				if(errorContainer) {
					errorContainer.empty();
				}

				let locationData = COSTCO.Header.extractLocationData(data);
				let invalidZip = locationData.InvalidZip;
		    	let province = locationData.Province;
				let country = locationData.Country;

	  	  		if(invalidZip) {
	  	  			if(errorContainer) {
	  	  				errorContainer.append(messages.ERR_GROCERY_INVALID_ZIP);
	  	  			}
	  	  			let inputContainer = $(element).find('.form-control');
	  	  			if(inputContainer){
	  	  				inputContainer.attr('aria-invalid','true');
	  	  				inputContainer.addClass("error");
	  	  			}
	  	  		} else {
	  	  			let stateInput = $(element).find("input[name='deliveryState']");
	  	  			if(stateInput) {
	  	  				stateInput.val(province);
	  	  			}
	  	  			let countryInput = $(element).find("input[name='deliveryCountry']");
	  	  			if(countryInput) {
	  	  				countryInput.val(country);
	  	  			}
		  	  		if(COSTCO.util.isCAStore()){
	  	  				let postalcode = $(element).find("#postal-code-input").val()
	  	  				$(element).find("#postal-code-input").val(postalcode.toUpperCase());
	  	  			}
	  	  			if($(element).data('confirm')){
	  	  				COSTCO.Header.showGroceryChangeModal(element);
			  	  		let id = $('#delivery-postal-change').attr('aria-describedby') || $('#delivery-postal-change').find('.popover').attr('id');
			  	        if (id) {
			  	          $(`#${id}`).popover('destroy');
			  	          COSTCO.util.hover_click_popover('#delivery-postal-change', '#delivery-postal-code-popover');
			  	  		}
	  	  			} else {
	  	  				COSTCO.Header.updateGroceryShipPostalCode(element);
	  	  			}
	  	  		}
  	  		};
  	  		let postalCode = element['deliveryPostalCode'].value;
  	  		if ($('#isGeocodeService').val() != "true") {
  	  			COSTCO.util.callBing(postalCode, updateDeliveryStateCountry);
  	  		} else {
  	  			COSTCO.util.callGeocodeAPI(postalCode, updateDeliveryStateCountry);
  	  		}
  	  	}
    	return false;
    },

    /**
     * Function to validate delivery zip code
     * 2 validation will be done
     * 	 1. Standard form validation postal regex and required
     *   2. Pass the zipcode to bing to also lookup country and state
     *   	which we will pass to the command to valid zipcode
     */
    setDeliveryValidateZipCode: function(element){
    	if (COSTCO.Header.isValidZipCode(element)) {
	  	  	if(typeof document.getElementById("isSetDeliveryInline") !== "undefined" && document.getElementById("isSetDeliveryInline") !== null)
			{
	  	  		document.getElementById("isSetDeliveryInline").value=true;
			}
	  	  let deliveryFormZipCode =null;
	  	  	if($('#postal-code-input') !== undefined && $('#postal-code-input') !== null)
	  	  		{
	  	  			 deliveryFormZipCode = $('#postal-code-input').val().trim();
	  	  		}
	  	  	else
	  	  		{
	  	  			 deliveryFormZipCode = $(element).serialize().split("&")[0].split("=")[1];
	  	  		}
	  	  	window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
  	  	}
  	  	else
  	  		{
		  	  	let errorContainer = $(element).find('div.error');
		  	  	if(errorContainer) {
					errorContainer.empty();
					errorContainer.append(messages.ERR_GROCERY_INVALID_ZIP);
				}
				let inputContainer = $(element).find('.form-control');
				if(inputContainer){
					inputContainer.attr('aria-invalid','true');
					inputContainer.addClass("error");
				}

		  	}
    },

    /**
     * Function used to show EDD date from narvar response
     */
    updateEDDView: function(eddDataInstance, observer) {
    	let langId = COSTCO.util.getLangId();
    	let groceryPdt = $('#groceryIdentifier').val();

		if($(eddDataInstance).text() !== "") {
			try {
				var data = $.parseJSON($(eddDataInstance).html());

				if (($(eddDataInstance).attr("data-costco-ship-mode-value")!== 'undefined' &&
				     $(eddDataInstance).attr("data-costco-ship-mode-value") !== '' ) && (
		    		 $(eddDataInstance).attr("data-costco-order-item") !== 'undefined' &&
					 $(eddDataInstance).attr("data-costco-order-item") !== ''))  {

					let eddFieldForUpdate = $(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value")+"_"+$(eddDataInstance).attr("data-costco-order-item"));
                    let eddDateForUpdate = $(".edd-non-formatted-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value")+ "_" + $(eddDataInstance).attr("data-costco-order-item"));

					// For warehouse pickup, since the shipmode used is the same as another normal shipmode
					if ($(eddDataInstance).attr("data-costco-shipping-type") !== undefined && $(eddDataInstance).attr("data-costco-shipping-type") !== '') {
						eddFieldForUpdate = $(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value")+"_"+$(eddDataInstance).attr("data-costco-order-item")+"_" + $(eddDataInstance).attr("data-costco-shipping-type"));
						eddDateForUpdate  = $(".edd-non-formatted-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value")+ "_" + $(eddDataInstance).attr("data-costco-order-item")+ "_" + $(eddDataInstance).attr("data-costco-shipping-type"));
					}

					$(eddFieldForUpdate).each(function()
					 {
						let dateToUse = data.formattedDate;
						// if the language is french, translate to French, otherwise, use the English
						if (langId === '-25') {
							dateToUse = new Date(data.rawDate).toLocaleDateString('fr-CA',{weekday: 'long', month : 'long', day:'numeric'});
				} else {
							dateToUse = new Date(data.rawDate).toLocaleDateString('en-US',{weekday: 'long', month : 'long', day:'numeric'});
				}

						$(eddFieldForUpdate).text(dateToUse);
						$(eddDateForUpdate).attr("value", (data.rawDate));

					});
				}
				$(".estimated-delivery-output").removeClass("hidden");

			} catch(err) {
				var nonJson = $(eddDataInstance).html();

				if (($(eddDataInstance).attr("data-costco-ship-mode-value")!== 'undefined' &&
					 $(eddDataInstance).attr("data-costco-ship-mode-value") !== '' ) && (
					 $(eddDataInstance).attr("data-costco-order-item") !== 'undefined' &&
					 $(eddDataInstance).attr("data-costco-order-item") !== ''))  {
					$(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value")+"_"+$(eddDataInstance).attr("data-costco-order-item")).each(function() {
						$(".edd-expected-date_" + $(eddDataInstance).attr("data-costco-ship-mode-value")+"_"+$(eddDataInstance).attr("data-costco-order-item")).text(nonJson);
					})
				} else {
					var edd_html = "";
					if(typeof(groceryPdt) !== 'undefined' && groceryPdt == "true"){
       			    	edd_html += COSTCO.util.tmpl('templ_edd_widget_grocery_error_v2', {});
       			    } else {
       			    	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
       			    		edd_html += COSTCO.util.tmpl('templ_edd_widget_error_v2', {});
           			    } else {
           			    	edd_html += COSTCO.util.tmpl('templ_edd_widget_error', {});
           			    }
       			 	}
					$('.edd-container').html(edd_html);
	      	    	COSTCO.util.hover_click_popover('#edd-postal-code-link-backup', '#edd-postal-code-popover')

				}
				$(".estimated-delivery-output").removeClass("hidden");
			}

				var duplicateDate = ""
				$(".delivery-option-radios[data-orderitem=" + $(eddDataInstance).attr("data-costco-order-item") + "]").find(".individualShipBlock").each(function(){

					var fieldToFind = ".edd-non-formatted-date_" + $(this).attr("data-shipmodeid") + "_" +$(this).attr("data-orderitem");

					if (typeof duplicateDate !== 'undefined' && duplicateDate !== "") {
						if (duplicateDate === $(this).find(fieldToFind).val() ||
							duplicateDate <= new Date($(this).find(fieldToFind).val())) {

							// mark the previous radio button as "checked"
							var previous = $(this).prev();
							var previousCheckBox = $(previous).find("INPUT.shipModeId")[0];
							// Make sure Checkbox exists before trying call the update shipmode method - this fixes infinite looping on Confirm Page
							if ($(previousCheckBox).length &&
								$(previousCheckBox).prop("checked") !== true &&
							    $($(this).find("INPUT.shipModeId")[0]).prop("checked") === true) {
								$(previousCheckBox).prop("checked",true);
								let previousElemOrderItem = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true ? $(previous).attr("data-orderitem") : $(previous).parent().attr("data-orderitem");
								COSTCO.OrderItems.update_shipmode.call($(previous), $(previous).attr("data-shipmodeid"), previousElemOrderItem);
							}

							// remove this second duplicate date from the screen
							$(this).remove();
						}
					}
					duplicateDate = $(this).find(fieldToFind).val();
					try {
						duplicateDate = new Date(duplicateDate);
					} catch(err) {
						// this is to catch any conversions that aren't a date - this is OK
					}
				});

				if(observer) {
					observer.disconnect();
				}
		}
    },

    /**
     * Function used to watch for changes to hidden div
    */
    startEDDMutationObserver: function() {
		console.log("EDD mutation observer is started");
		$('.eddData').each(function() {
			var targetObject = this;
			var observerObject =  new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
					mutationRecordsList.forEach(function(mutation) {
					if ("attributes" === mutation.type || "childList" ===  mutation.type ||  "subtree" ===  mutation.type) {
						COSTCO.Header.updateEDDView(targetObject, observerObject);
						}
					});
				});
			// Register the target node to observe and specify which DOM changes to watch
			observerObject.observe(targetObject, {
				attributes: true,
				attributeOldValue: true,
				childList: true,
				subtree: true,
				characterData: true
			});
		})

	},

	narvarEventAdded: false,

    /**
     * Function used to attempt to create the grocery zip code cookie and if unsuccessful,
     * call the Grocery Zip Code Modal function
     * 1. If cookie already exists, do nothing
     * 2. If cookie doesn't exist, but user is logged in and has default ship code
     *    cookie, then use that
     * 3. If neither of the above are true, try to get the zip code from the Akamai
     *    Cookie (client-zip-code)
     * 4. If all three above aren't possible, calls Grocery Zip Code Modal function
     */
	manageGroceryZipCode: function() {
    	let invCheckPostalCode = $.cookie('invCheckPostalCode');
    	let memberPrimaryPostal = $.cookie('memberPrimaryPostal');
    	let akamaiZipEnabled = $('#akamaiZipEnabled').val();
    	let customAkamaiZip = $.cookie('client-zip-short');
    	let finalZipCode = null;

    	let updateGroceryCookies = function(data, textstatus, XMLHttpRequest) {
    		let province = null;
    		let country = null;

  		try {
				//Check out if country is Puerto Rico specific
  				country = data.resourceSets[0].resources[0].address.countryRegionIso2;
				if (country != undefined && country === 'PR') {
					province = data.resourceSets[0].resources[0].address.countryRegionIso2;
					country = 'US';
				} else {
					province = data.resourceSets[0].resources[0].address.adminDistrict;
				}
	        }
	  		catch (e) {
	  		  province = null;
	  		  country = null;
	        }

	  		if (province != null &&
	  		   ((COSTCO.util.isCAStore() && country === 'CA') ||
	  		    (!COSTCO.util.isCAStore() && country === 'US')))
	  		{
   			 // The expiry time is based on the arbitrary calculation in the AjaxUpdateDeliveryPostalCmdImpl class
   			 // (70*3600*365 seconds) which equals 1064.5 days
	  			$.cookie('invCheckStateCode', province, {path: "/", expires: 1064});
	  			$.cookie('invCheckPostalCode', finalZipCode, {path: "/", expires: 1064});
	  			//invoke OMS API for setting Warehouse Cookie.
	  			//COSTCO.Header.invokeOMSLocationApi(finalZipCode, province, "");
		    	COSTCO.Header.updateGroceryShipPostalCodeDisplay();
		    	let isPDP = $('#productPage').val();
		    	if(isPDP) {
		    		COSTCO.Header.startEDDMutationObserver();
		    		COSTCO.Header.showEDDWidget();

		    	}
	  		}
	  		else {
	  			// no cookies were set - remove the session variable
	  			COSTCO.util.removeFromSession("isZipSetByAkamai");
  	  			}
	  		// Show ZipCode overlay for CA only
	  		if(!COSTCO.util.isDepotCatalogEnabled())
  			{
  			     COSTCO.Header.showGroceryZipCodeInventoryModal();
	  	  			}
	  	  			}
    	// Determine if the cookie already exists
    	if (!invCheckPostalCode || invCheckPostalCode === '') {
    		// Determine whether the default shipping address exists
    		if (!memberPrimaryPostal || memberPrimaryPostal === '') {
    			//if Akamai Zip Enabled in XAPP
    			if (akamaiZipEnabled === '1' && customAkamaiZip ) {
    				//Validate that akamai zip is in the country the store is in
    				let postalValidationRegex = null;
    				if(COSTCO.util.isCAStore()){
    					postalValidationRegex = COSTCO.util.POSTAL_CODE_REGEX_CA;
    				}
    				else if(COSTCO.util.isUSStore()){
    					postalValidationRegex = COSTCO.util.POSTAL_CODE_REGEX_US;
    				}
    				if(postalValidationRegex.test(customAkamaiZip) || customAkamaiZip.length == 3) { //3 chars for canada FSA
    					finalZipCode = customAkamaiZip;
    				}
    			}
    		}
    		else {
    			// If default shipping address exists, use it
    			finalZipCode = memberPrimaryPostal;
    		}
    	}

    	//Avoiding this call in shipping page so that contract items
    	//get merged properly on proceeding from shipping page
    	if (typeof checkoutPage === 'undefined' || checkoutPage !== 'shipping'){
    		if (finalZipCode !== null) {
        		// Calling service to retrieve the Province / State
    			if ($('#isGeocodeService').val() != "true") {
    				COSTCO.util.callBing(finalZipCode, updateGroceryCookies, updateGroceryCookies);
		    	} else {
		    		COSTCO.util.callGeocodeAPI(finalZipCode, updateGroceryCookies, updateGroceryCookies);
		    	}
        	} else {
        		// Show ZipCode overlay for CA only
    	  		if(!COSTCO.util.isDepotCatalogEnabled())
      			{
      			     COSTCO.Header.showGroceryZipCodeInventoryModal();
      			}
        	}
    	}

    	//Populate Warehouse Cookie for BC US
//    	if(!COSTCO.util.isBDStore()){
//		//Depot Catalog Online Changes-For Populating Warehouse Cookie
//    	let zipCode = $.cookie('invCheckPostalCode');
//    	let stateCode = $.cookie('invCheckStateCode');
//    	let warehouseVal = $.cookie('WAREHOUSEDELIVERY_WHS');
//    	/*
//		 * If zipCode and state Cookie are there and Warehouse Cookie is not
//		 * there,then make AJAX call to populate Warehouse Cookie
//		 */
//    	if((null !== zipCode && zipCode !== undefined && zipCode.length > 0) && (null !== stateCode && stateCode !== undefined && stateCode.length > 0)
//    			&& (typeof warehouseVal === 'undefined' || null === warehouseVal || '' === warehouseVal || warehouseVal.includes('NA'))) {
//    		//invoke OMS API for setting Warehouse Cookie.
//    		COSTCO.Header.invokeOMSLocationApi(zipCode,stateCode,"");
//    	}
//     }
    },
    /**
     * Function used to create the required entry pop-up which will prompt
     * user to enter their grocery delivery zip code
     * Form input will be validated using the standard regex to check for valid form
     *
     */
    showGroceryZipCodeInventoryModal: function() {
    	//Check if the delivery postal container in the minibar is visible
    	let invCheckPostalCode = $.cookie('invCheckPostalCode');

    	let loadPostalModal = false,loadRegionModal=false;
		let isRegionValid = $.cookie('C_2LOC');
		let groceryPdt=$('#groceryIdentifier').val();
		let isCaGrocery = COSTCO.util.isCAStore() &&
				(COSTCO.util.hasGroceryProducts() || (groceryEnabled && typeof(groceryPdt) !== 'undefined' && groceryPdt == 'true'));
		if(
			((isCaGrocery && isRegionValid == 'true') || !COSTCO.util.isCAStore()) &&
				$('#delivery-postal-container').is(':visible') &&
				 (!invCheckPostalCode || invCheckPostalCode == '') &&
				  !COSTCO.Header.checkIsGroceryModalDisplayed()) {
			loadPostalModal = true;
		}
		else if(isCaGrocery && isRegionValid == 'false' && !COSTCO.Header.checkIsGroceryVisited()){
			loadRegionModal = true;
		}
    	if(loadPostalModal){
    		var modalOptions = {
    		        title: '',
    		        body: COSTCO.util.tmpl('tmpl_delivery_postal_modal'),
    	    		keyboard: false,
    	    		backdrop: 'static',
    	    		hideHeader: true,
    	    		hideFooter: true,
    	    		preventClose: false,
    	    		onshown: function(e) {
						if(COSTCO.util.isCAStore()){
							COSTCO.Header.maskInput();
							$('#postal-code-input').unbind('click').on('click', function(){
								$('#postal-code-input').val('');
								$('div#postal-code-error').each(function(){
									$( this ).addClass('hide');
								})
								.addClass('hide');
								$('#postal-code-submit').removeClass('hide');
							});
						}
						$('#postal-code-input').focus();
					}
    		    }
    	    	COSTCO.dialog.showAndHideModal(modalOptions);
    			COSTCO.util.setInSession("isGroceryModalDisplayed", true);

    		window.scrollTo(0,0);
    	} else if(loadRegionModal){
    		COSTCO.util.setInSession("isGroceryVisited", true);
    		COSTCO.Header.showGroceryPostalRestrictionModal();
    		window.scrollTo(0,0);
    	}
    },
    submitZipcode: function() {
    	COSTCO.Header.updateGroceryShipPostalCodeDisplay();
  	    COSTCO.dialog.close();
    },



    /**
     * If Zip Code doesn't exist, pop open the Modal Window
     */
    validateZipCodeExists : function (event) {
    	if (groceryEnabled && $('#delivery-postal-container').is(':visible') &&
    	   (!$.cookie('invCheckPostalCode') || $.cookie('invCheckPostalCode') == '')) {
    		event.preventDefault();
        	event.stopImmediatePropagation();
        	COSTCO.util.removeFromSession("isGroceryModalDisplayed");
        	COSTCO.Header.showGroceryZipCodeInventoryModal();
        	// if we display the Grocery Code Modal, send that information back to the caller
        	return true;
    	} else {
    		// if we don't display the Grocery Code modal, send that information back to the caller
    		return false;
    	}
    },

    showGroceryPostalRestrictionModal: function() {
    	var modalOptions = {
    			title: '',
    			body: COSTCO.util.tmpl('tmpl_delivery_postal_restriction_modal'),
    			keyboard: false,
    			backdrop: 'static',
    			hideHeader: true,
    			hideFooter: true,
    			preventClose: true,
    			onshown: function(e) {
    				$('#postal-code-continue').focus();
    			}
    	}
    	COSTCO.dialog.showAndHideModal(modalOptions);
    },

    deliveryPostalContinueShopping : function(data) {
    	if(data.errorMessage) {
    		if(COSTCO.util.isCAStore()){
    			$('.alert-notification').removeClass('hide');
    			$('.alert-notification').empty();
    			let error = COSTCO.util.get_decoded_html(data.errorMessage);
    			$('.alert-notification').append(error);

    			$("#costcoModalBtn2").off("click").on("click", function(){
    				COSTCO.Header.updateGroceryShipPostalCodeDisplay();
    				if(localStorage){
    					localStorage.setItem("isRestrictedPostalCode", 'true');
    				}
    				COSTCO.dialog.close();
    			});
    		}else{
    			$('.critical-notification').empty();
    			let error = COSTCO.util.get_decoded_html(data.errorMessage);
    			$('.critical-notification').append(error);
    			$('.critical-notification').removeClass('hide');
    			COSTCO.util.announceSRMessage(error);
    		}
    	}else{
    		if(COSTCO.util.isCAStore()){
      		  	if(localStorage){
					localStorage.setItem("isRestrictedPostalCode", 'false');
				}
      	  	}
    		COSTCO.Header.updateGroceryShipPostalCodeDisplay();
    		COSTCO.dialog.close();
    		if (typeof (COSTCO.Lists) !== "undefined") {
				window.removeEventListener("beforeunload", COSTCO.Lists.leavePagePopup);
			}
    		//STRY0143973-To reload the page when zipcode is changed
    		if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart') {
    			window.location.href="/CheckoutCartView";
    		}else{
    			if(!window.location.href.includes('/Logoff')){
    			window.location.reload();
    		}

    	}
    	}
    },
    /**
     * Function used to show the confirmation dialog when user change
     * their grocery zip code
     */
    showGroceryChangeModal: function(form) {
    	let oldPostal = null;
    	let oldState = null;
    	let newPostal = null;
    	oldPostal = $.cookie('invCheckPostalCode');
    	oldState = $.cookie('invCheckStateCode');
    	newPostal = form['deliveryPostalCode'].value;
    	if(COSTCO.util.isCAStore()){
    		if(oldPostal!=null){
    		    oldPostal=oldPostal.replace(/\+/g,' ');
    		}
    	}
    	let callBackFn = COSTCO.Header.deliveryPostalContinueShopping;
    	// If Canada, continue showing the error unless they cancel out of the window
    	if(COSTCO.util.isCAStore()){
    		callBackFn = "";
    	}
    	var modalOptions = {
	        title: messages.GROCERY_POSTAL_CHANGE_CONFIRM_TITLE,
	        body: COSTCO.util.tmpl('tmpl_delivery_postal_confirm', {
	        		 	old_postal: oldPostal,
	        		 	new_postal: newPostal
	        			}),
	        primary: messages.GROCERY_POSTAL_CHANGE_CONFIRM_TITLE,
	        secondary: messages.BUTTON_CANCEL,
    		primary_event: function() {COSTCO.Header.updateGroceryShipPostalCode(form, callBackFn)},
    		secondary_event: function() {
    			if(COSTCO.util.isCAStore()){
	    			 // The expiry time is based on the arbitrary calculation in the AjaxUpdateDeliveryPostalCmdImpl class
	    			 // (70*3600*365 seconds) which equals 1064.5 days
    				$.cookie('invCheckPostalCode', oldPostal, {path: "/", expires: 1064});
    				$.cookie('invCheckStateCode', oldState, {path: "/", expires: 1064});
    				COSTCO.Header.updateGroceryShipPostalCodeDisplay();
    			}
    			COSTCO.dialog.close();
    		}
	      }
    	COSTCO.dialog.showAndHideModal(modalOptions);
    },

    /**
     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
     */
    maskInput : function() {
		var langId = COSTCO.util.getLangId();
    	if (langId == -1) {
    		$('#postal-code-input').mask('00000-0000');
    		$('#edd-zip-code-field').mask('00000-0000');
    		$('#eddZipCodeField').mask('00000-0000');
    	}
    	else if (langId == -24 || langId == -25) {
    		$('#postal-code-input').mask('S0S 0S0');
    		$('#edd-zip-code-field').mask('S0S 0S0');
    		$('#eddZipCodeField').mask('S0S 0S0');
    	}
	},

    /**
     *
     */
    showBanner: function() {

      $('#top-bar').show();
	  if(COSTCO.util.hasGroceryProducts() || COSTCO.util.groceryDefaultHomepage()){
		  setTimeout(function(){
			  $('#banner-list-actions').show();
		  }, 1000);
	  }
      let bannerCrumbsList = $('#crumbs_ul li');
      let isGroceryCat=$('#grocerySection').val();
      let pdtIdentifer=$('#parentIdentifier').val();
      let isCat = $('#crumbs_ul').data("iscat");
      let groceryIdentifier='';
      let isPDP = $('#productPage').val();
      let groceryPdt=$('#groceryIdentifier').val();

      if($('#groceryDefaultHomepage').length!= 0){
    	 groceryIdentifier=$('#groceryDefaultHomepage').val().split("/")[1].split(".")[0];
      }
      // Showing mini banner on Cart page with grocery item
      // Showing mini banner on Confirmation page with grocery item added
      if (typeof checkoutPage != 'undefined' && ( checkoutPage == 'cart' || checkoutPage == 'confirmation')) {
          if($.cookie('grocSurchargeCookie') != 0) {
        	  $('#grocery-amts').hide();
        	  $('#frozen-amts').hide();
        	  $('#mobile-grocery-frozen-amts').hide();
        	  $('#mobile-grocery-amts').hide();
        	  $('#mobile-frozen-amts').hide();
          }
          else{
        	  $('#grocery-amts').show();
        	  $('#frozen-amts').show();
        	  $('#mobile-grocery-frozen-amts').show();
        	  $('#mobile-grocery-amts').show();
        	  $('#mobile-frozen-amts').show();
          }
      }
      // Showing mini banner on search result pages
      else if (bannerCrumbsList.length != 0 && COSTCO.util.isUSStore() && COSTCO.util.hasGroceryProducts()) {
    	  $('#grocery-amts').show();
    	  $('#frozen-amts').show();
    	  $('#mobile-grocery-frozen-amts').show();
    	  $('#mobile-grocery-amts').show();
    	  $('#mobile-frozen-amts').show();
     	// To make bread crumb hidden in grocery landing page
         if (isCat && bannerCrumbsList.length >2){
       	  $('#crumbs_ul').show();
         }else if(!isCat&&bannerCrumbsList.length >= 2){
         	$('#crumbs_ul').show();
         }

      }else if (bannerCrumbsList.length != 0 && COSTCO.util.isCAStore() && COSTCO.util.hasGroceryProducts()) {
    	  if(COSTCO.util.is2DayEligbleRegn()){
      			$('#grocery-amts').show();
        	  }
    	  // To make bread crumb hidden in grocery landing page
            if (isCat && bannerCrumbsList.length >2){
          	  $('#crumbs_ul').show();
            }else if(!isCat&&bannerCrumbsList.length >= 2){
            	$('#crumbs_ul').show();
            }
      }else if (COSTCO.util.isUSStore() && ((null!=pdtIdentifer && pdtIdentifer != "" &&
    		  pdtIdentifer == groceryIdentifier) || (typeof(groceryPdt) !== 'undefined' && groceryPdt == 'true'))) {  // for product details page
              $('#grocery-amts').show();
              $('#frozen-amts').show();
              $('#mobile-grocery-frozen-amts').show();
              $('#mobile-grocery-amts').show();
        	  $('#mobile-frozen-amts').show();
            if (bannerCrumbsList.length >= 2) {
              $('#crumbs_ul').show();
            }
      }else if(COSTCO.util.isCAStore() && isPDP != undefined && isPDP == 'true'){
    	  if(groceryEnabled && COSTCO.util.is2DayEligbleRegn() && typeof(groceryPdt) !== 'undefined' && groceryPdt == 'true'){
        		$('#grocery-amts').show();
        	}
    	  if (bannerCrumbsList.length >= 2) {
              $('#crumbs_ul').show();
            }
      }
      else {
    	$('#crumbs_ul').show();
    	$('#grocery-amts').hide();
    	$('#frozen-amts').hide();
    	$('#mobile-grocery-frozen-amts').hide();
    	$('#mobile-grocery-amts').hide();
  	  	$('#mobile-frozen-amts').hide();

      }

      $('#banner-list-actions').hide();

  	  var minibanner = $('.mini-banner');
  	  if(minibanner != null && minibanner.is(":visible")) {
  	     $('#banner-list-actions').show();
  	  }

      // If grocery mini banner is shown then we need to check if we have
      // postal code for zip code inventory check only if the flow is enabled.
      if(validateGroceryDeliveryZip){
    	 if(($.cookie('invCheckPostalCode') != null && $.cookie('invCheckPostalCode') != '')
    	   ||($.cookie('memberPrimaryPostal') != null && $.cookie('memberPrimaryPostal') != '')) {
    		 if ($.cookie('invCheckPostalCode') == null || $.cookie('invCheckPostalCode') == '') {
    			 let memberPrimaryPostal = $.cookie('memberPrimaryPostal');
    			 let memberPrimaryStateCode = $.cookie('memberPrimaryStateCode');
	    		 if(!COSTCO.util.isCAStore()){
	    			 // The expiry time is based on the arbitrary calculation in the AjaxUpdateDeliveryPostalCmdImpl class
	    			 // (70*3600*365) which equals 1064.5 days
    				 $.cookie('invCheckPostalCode', memberPrimaryPostal, {path: "/", expires: 1064});
    				 $.cookie('invCheckStateCode', memberPrimaryStateCode, {path: "/", expires: 1064});
    			 }
    		 }
    	 }
    	 COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	  }
    },
    resetSearch: function() {
     var appType = $('#applicationType').val();
     var isGroceryFilterSelected=$('#is_grocery_Filter_Selected').val();
     if (!(appType == 'BD')){
      let currenturl = window.location.href;
      searchselected = new RegExp('[\?&]dept=([^&#]*)').exec(currenturl);
      bannerCrumbsList = $('#crumbs_ul li');
      type = 'Grocery';
      reset = false;
      let groceryIdentifier='';
      if($('#groceryDefaultHomepage').length!= 0){
    	 groceryIdentifier=$('#groceryDefaultHomepage').val().split("/")[1].split(".")[0];
      }
      let pdtIdentifer=$('#parentIdentifier').val();
      if (COSTCO.util.hasGroceryProducts()){
    	  reset = true;
      }else if (groceryEnabled && null != pdtIdentifer && pdtIdentifer != "" &&
    		  pdtIdentifer == groceryIdentifier) {
          reset = true;
        }else if (null != searchselected && searchselected[1] != null && searchselected[1] == type) {
            reset = true;
        }
      if (reset) {
    	  var groceryHomepage=COSTCO.util.groceryDefaultHomepage().split('/')[1];
    	  $("#search-dropdown-select").val(groceryHomepage).prop('selected',true);
    	  $('#search-dropdown-select').change();
    	  $('#search-field').value = '';
      }
     }
    },
    /**
     * Check if session storage has grocery order params, else fire AJAX call to
     * fetch values.
     * If session storage have values update mini banner with the data
     *
     * @return {void} [description]
     */
    refreshGroceryOrderParams: function() {
    	try {
	    	COSTCO.Header.refreshGroceryBanner();
	    } catch (e) {
	      console.log('Error fetching and setting params');
	      //this.fetchGroceryOrderParams();
	    }
    },
    /**
    *
    * Function call that is used to update the delivery postal code
    *
    */
    updateGroceryShipPostalCode:function(form, callBack) {
    	try {
    		COSTCO.util.ajax({
    	        url: '/AjaxUpdateDeliveryPostal',
    	        type: 'POST',
    	        data: $(form).serialize(),
    	        done: callBack ? function(data){callBack(data)} :
	    	        function(data) {
	    	        	if(data.errorMessage) {
	    	        		if(COSTCO.util.isCAStore()){
	    	            		if(localStorage){
	    	    					localStorage.setItem("isRestrictedPostalCode", 'true');
	    	    				}
	    	            		//CA-GRO Implementation
	    	            		$('.alert-notification').empty();
	    	        			$('.alert-notification').append(COSTCO.util.get_decoded_html(data.errorMessage));
	    	        			$('.alert-notification').removeClass('hide');
	    	            		$('#postal-code-continue').removeClass('hide');
	    	        		}else{
	    	        			$('.critical-notification').empty();
	    	        			let error = COSTCO.util.get_decoded_html(data.errorMessage);
	    	        			$('.critical-notification').append(error);
	    	        			$('.critical-notification').removeClass('hide');
	    	        		}
	    	        	}
	    	          else {
	    	        	  if(COSTCO.util.isCAStore()){
	    	        		  if(localStorage){
	    	  					localStorage.setItem("isRestrictedPostalCode", 'false');
	    	  				}
	    	        	  }
	    	        	  COSTCO.Header.updateGroceryShipPostalCodeDisplay();
	    	        	  COSTCO.dialog.close();
	    	        	  if (typeof (COSTCO.Lists) !== "undefined") {
	    	        		  window.removeEventListener("beforeunload", COSTCO.Lists.leavePagePopup);
	    	        	  }
	    	        	  window.location.reload();
	    	          }
	            	},
            	fail: function(data) {
            		$('.critical-notification').empty();
  	        	  	$('.critical-notification').append( "<p>Unexpected Error Encountered</p>" );
  	        	  	$('.critical-notification').removeClass('hide');
            	}
    	      });
    	}
    	catch(e) {
    		console.log('Error AjaxRefreshMiniBanner ajaxcall');
    	}
    },

    /**
     * Function used to update the delivery zip code display in the minibar with the postalcode
     * from the cookie
     */
    updateGroceryShipPostalCodeDisplay: function() {
    	let postalCode = $.cookie('invCheckPostalCode');
    	let postalCodeContainer = $('#delivery-postal-container');
    	// Only show zip in cart page if globalMiniBanner is enabled
      let showZip = !(typeof globalMiniBannerFlag !== 'undefined' && globalMiniBannerFlag === '0' &&
      		typeof checkoutPage !== 'undefined' && checkoutPage === 'cart');
    	if (showZip) {
    		postalCodeContainer.removeClass('hide');
    	}
    	if(postalCodeContainer.length > 0 && postalCode!= null && postalCode!='') {
    		postalCodeContainer.empty();
    		if(COSTCO.util.isCAStore()){
    			/*This is done to replace the encoded ' + ' sign of Canada postal zipcode with a space character .*/
    			postalCodeContainer.append(COSTCO.util.tmpl('tmpl_delivery_postal_text', {postalCode: postalCode.replace(/\+/g,' ')}));
    		}else{
    			postalCodeContainer.append(COSTCO.util.tmpl('tmpl_delivery_postal_text', {postalCode: escape(postalCode)}));
    		}

        	COSTCO.util.click_popover('#delivery-postal-change', '#delivery-postal-code-popover');
    	}
    	COSTCO.Header.updateSamedayLinks();

    	// If global zip changes and we are on the Cart Page, and the Cart
    	// Page is not empty, recalculate the Shipping Costs and update
    	// the estimated shipping zip in the lower right corner
    	if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart') {
    		if($.cookie('cartCountCookie') !== null && $.cookie('cartCountCookie') > 0 ) {
    			if (typeof document.getElementById("order-estimated-zip") !== "undefined" && document.getElementById("order-estimated-zip") !== null) {
         	    	if (typeof document.getElementById("order-estimated-zip").getElementsByTagName("a")[0] !== "undefined") {
         	    		let estimatedShippingZip = document.getElementById("order-estimated-zip").getElementsByTagName("a")[0].text;
         	        	if (estimatedShippingZip !== "" &&
         	        		estimatedShippingZip !== postalCode) {
         	          	  	$("#shipping-costs-zip").val(postalCode);
         	        	}
         	    	} else {
         	    		if (typeof document.getElementById("shipping-costs-zip").text === "undefined") {
         	    			$("#shipping-costs-zip").val(postalCode);
         	    		}
         	    	}
           	}
    	}
    	}
    },

    /**
     * Dynamically refresh mini banner to shows status of grocery order
     * after AJAX calls
     * @param  {[type]} data [description]
     * @return {void}      [description]
     */
    refreshGroceryBanner : function(){
    	let groceryMiniBannerCookie = $.cookie('C_GOP');
    	if($('#grocery-amts').length > 0) { //Mini banner displayed
            //default values displayed on grocery landing pages
    		let grocerythreshold = $('.amount-base').attr('data-amount-base');
    		let frozenthreshold = $('.frozen-amount-base').attr('data-frozen-amount-base');
        	let data = {'Grocery':{"orderTotal":"0.00","deliveryFee":"0.00","threshold":grocerythreshold},'Frozen' : {"orderTotal":"0.00","deliveryFee":"0.00","threshold":frozenthreshold}};
        	if ($('#top-bar').length > 0 && groceryMiniBannerCookie && groceryMiniBannerCookie != '""') {
            	data = JSON.parse(COSTCO.util.decode(groceryMiniBannerCookie));
        	}
            let currentOrder = data.Grocery.orderTotal || 0.00;
            let amountBase      = data.Grocery.threshold || 0.00;
            let amountToGoValue = data.Grocery.amountToGo || data.Grocery.threshold;
            let deliveryFee     = data.Grocery.deliveryFee || 0.00;

            let currentFrozenOrder = data.Frozen.orderTotal || 0.00;
            let frozenAmountBase      = data.Frozen.threshold || 0.00;
            let frozenAmountToGoValue = data.Frozen.amountToGo || data.Frozen.threshold;
            let frozenDeliveryFee     = data.Frozen.deliveryFee || 0.00;

            // The total of grocery products added to order that qualify against
            // eliminating the delivery fee.

            $('#grocery-order-total').text(COSTCO.util.formatMoney(currentOrder, true));

            // Represents the verbiage that shows right of the "Current Order: $$$"
            // showing the amount left (if any) the user needs to add to cart to
            // avoid a delivery fee.
            $('#grocery-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_left_to_go', {
              currentOrder: parseFloat(currentOrder),
              amountBase: parseFloat(amountBase),
              amountToGo: parseFloat(amountToGoValue),
              deliveryFee: deliveryFee,
            }));

            let grocerytogoTooltipText = groceryProgramMessages['MINIBANNER_GROCERY_MSG'];
            let currentTooltipText = $('#grocery-left-to-go-tooltip button.a11y-tooltip').attr('data-content');

            if(typeof grocerytogoTooltipText !== 'undefined' && grocerytogoTooltipText !== null && grocerytogoTooltipText !== '' && grocerytogoTooltipText !== currentTooltipText){
         		grocerytogoTooltipText = grocerytogoTooltipText.replace('{0}',grocerythreshold);
         		$('#grocery-left-to-go-tooltip button.a11y-tooltip').attr('data-content', grocerytogoTooltipText)

         	}

            if(wcs.storeId == '10301'){
            	$('#frozen-order-total').text(COSTCO.util.formatMoney(currentFrozenOrder, true));
            	$('#mobile-grocery-order-total').text(COSTCO.util.formatMoney(currentOrder, true));
                $('#mobile-frozen-order-total').text(COSTCO.util.formatMoney(currentFrozenOrder, true));
                // Represents the verbiage that shows right of the "Current Order: $$$"
                // showing the amount left (if any) the user needs to add to cart to
                // avoid a delivery fee.
                $('#mobile-grocery-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_mobile_left_to_go', {
                  currentOrder: parseFloat(currentOrder),
                  amountBase: parseFloat(amountBase),
                  amountToGo: parseFloat(amountToGoValue),
                  deliveryFee: deliveryFee,
                }));

                $('#mobile-frozen-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_cnf_mobile_left_to_go', {
                    currentOrder: parseFloat(currentFrozenOrder),
                    amountBase: parseFloat(frozenAmountBase),
                    amountToGo: parseFloat(frozenAmountToGoValue),
                    deliveryFee: frozenDeliveryFee,
                  }));

                $('#frozen-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_cnf_left_to_go', {
                    currentOrder: parseFloat(currentFrozenOrder),
                    amountBase: parseFloat(frozenAmountBase),
                    amountToGo: parseFloat(frozenAmountToGoValue),
                    deliveryFee: frozenDeliveryFee,
                }));

                let frozentogoTooltipText = groceryProgramMessages['MINIBANNER_FROZEN_MSG'];
         		let currentFrozenTooltipText = $('#frozen-left-to-go-tooltip button.a11y-tooltip').attr('data-content');
         		if(typeof grocerytogoTooltipText !== 'undefined' && grocerytogoTooltipText !== null && grocerytogoTooltipText !== '' && grocerytogoTooltipText !== currentTooltipText){
             		grocerytogoTooltipText = grocerytogoTooltipText.replace('{0}',grocerythreshold);
             		$('#mobile-grocery-left-to-go-tooltip button.a11y-tooltip').attr('data-content', grocerytogoTooltipText)

             	}
             	if(typeof frozentogoTooltipText !== 'undefined' && frozentogoTooltipText !== null && frozentogoTooltipText !== '' && frozentogoTooltipText !== currentFrozenTooltipText){
             		frozentogoTooltipText = frozentogoTooltipText.replace('{0}',frozenthreshold);
             		$('#mobile-frozen-left-to-go-tooltip button.a11y-tooltip').attr('data-content', frozentogoTooltipText)

             	}

             	if(typeof frozentogoTooltipText !== 'undefined' && frozentogoTooltipText !== null && frozentogoTooltipText !== '' && frozentogoTooltipText !== currentFrozenTooltipText){
             		frozentogoTooltipText = frozentogoTooltipText.replace('{0}',frozenthreshold);
             		$('#frozen-left-to-go-tooltip button.a11y-tooltip').attr('data-content', frozentogoTooltipText)

             	}
            }
          }
    },

    getCookie: function(cookieName) {
      let name = cookieName + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    },
    /**
     * This function relates to STRY0132341 - Modal windows are generating javascript errors when dragging cursor in text boxes.
     * This fix is for Delivery ZIP Code pop over click mouse cursor in the input field and hold the mouse, drag it do search box - you will see javascript:void(0) copied over.
     * @return {void} [description]
     */
    prevent_drop_dragovers: function() {
      // The fix is for all text boxes appearing not restricted to ZIP code popover
      $('body').on('dragover', function(e) {
      	e.preventDefault();
      })
      $('body').on('drop', function(e) {
    	e.preventDefault();
      });
    },
    /**
     * This function initializes the popover for
     * the "Find a Warehouse" feature.
     * @return {void} [description]
     */
    setup_popovers: function() {
      // Thanks stackoverflow for this - fixes all of the issues with bootstrap popovers
      $('body').on('hidden.bs.popover', function(e) {
        $(e.target).data('bs.popover').inState.click = false;
      });

      let memberCookie = COSTCO.util.getMemberCookie();
      if (memberCookie.signedIn == true) {
      	$('#myaccount-t, #myaccount-m').attr('href', 'javascript:void(0);'); //set links to void so user can click for my account popover
        COSTCO.util.hover_click_popover('#myaccount-t', '#my-account-popover');
        COSTCO.util.hover_click_popover('#myaccount-m', '#my-account-popover');
      }
      COSTCO.util.hover_click_popover('#myaccount-d', '#my-account-popover');
      COSTCO.util.click_popover('#delivery-postal-change', '#delivery-postal-code-popover');

      $('.minibanner-help').popover({
          trigger: 'focus',
          placement: 'bottom',
        });

    },

    isWcsSessionExpired: function() {

    	try{
    		var kmsi = $.cookie('kmsi');
    		if(typeof kmsi != 'undefined' && kmsi != null && kmsi.indexOf("true") >= 0 ){

    			var hashedUserId = $.cookie('hashedUserId');

    			if(hashedUserId == undefined || typeof hashedUserId == 'undefined' || hashedUserId == null || hashedUserId ==''){
    				return true;
    			}

    			var kmsiVal = kmsi.split('_');
    			if(typeof kmsiVal != 'undefined' && kmsiVal != null && kmsiVal.length > 1){
    				kmsiVal = kmsiVal[1];
    				if(Date.now() - kmsiVal > wcs.loginTimeOut){
    					return true;
    				}else{
    					return false;
    				}
    			}
    		}

    		return false;

    	}catch(e){
    		return false;
    	}

    },


    isKmsiEnabled: function() {
    	return costcoStoreFeatures!= null
		&& costcoStoreFeatures.SSO_KMSI != null
		&& costcoStoreFeatures.SSO_KMSI != undefined
		&& costcoStoreFeatures.SSO_KMSI;
    },
    isTimeOutFixEnabled: function() {
    	return costcoStoreFeatures!= null
		&& costcoStoreFeatures.SSO_KMSI_LOGOUTFIX != null
		&& costcoStoreFeatures.SSO_KMSI_LOGOUTFIX != undefined
		&& costcoStoreFeatures.SSO_KMSI_LOGOUTFIX;
    },
    isKmsiRedirectEnabled: function() {
    	return costcoStoreFeatures!= null
		&& costcoStoreFeatures.SSO_KMSI_REDIRECT != null
		&& costcoStoreFeatures.SSO_KMSI_REDIRECT != undefined
		&& costcoStoreFeatures.SSO_KMSI_REDIRECT;
    },

    /**
     * This function is used to keep the user sign in, if the user opted for it
     */
    kmsi: function() {

    	 try {
             if (COSTCO.Header.isKmsiEnabled() && COSTCO.Header.isKmsiSession() && COSTCO.Header.isWcsSessionExpired()) {
               var e = this;
               var xhr = new XMLHttpRequest();
               xhr.open("GET", "/kmsi", false);
               xhr.onreadystatechange = function () {
                 if (xhr.readyState === 4) {
                   if (xhr.status == 200) {
                     try {
                       var t = JSON.parse(xhr.responseText);
                       if ("true" == t.kmsi) {
                         COSTCO.Header.kmsiCount = 0;
                         e.signInOutContainerInit();
                         e.miniShopCartRefresh();

                         if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart'  && !COSTCO.Header.isWcsSessionExpired()){
 							window.location.reload();
 						 }

                       } else if (COSTCO.Header.kmsiCount < 3) {
                         COSTCO.Header.kmsiCount++;
                         COSTCO.util.safe(this.kmsi());
                       }
                     } catch (e) {
                       console.error(e);
                     }
                   } else {
                     console.error("Request failed with status: /kmsi ", xhr.status);

                     if (COSTCO.Header.isKmsiRedirectEnabled() && COSTCO.Header.isWcsSessionExpired()) {
                       window.location = "/LogonForm?prompt=false&fromPage=/"; // Redirect if conditions are met
                     }
                   }
                 }
               };

               xhr.send();

             }
           } catch (e) {
             console.log(e);
           }
    },


    //Retruns if the user is a KMSI or not
    isKmsiSession: function(){

    	try{

    		var kmsi = $.cookie('kmsi');
    		if(typeof kmsi == 'undefined' || kmsi == null || kmsi  == 'false'){
    			return false;
    		}

    	}catch(e){
    		console.log(e);
    	}

    	return true;

    },

    validateVendor: function(urlVal){

    	try{
	    	var hashedUserId = $.cookie('hashedUserId');
			var urlRedirection=($.trim(urlVal).length !== 0 && urlVal.includes('att.com')) ? ('/logon-att?URL='+urlVal) : urlVal;

	    	if(COSTCO.Header.isKmsiSession() || !(hashedUserId == undefined || typeof hashedUserId == 'undefined' || hashedUserId == null || hashedUserId =='')){
	    		if(COSTCO.util.getMemberCookie().costcoMember && COSTCO.util.getMemberCookie().active) {
	    			window.location.href=urlRedirection;
	    		} else {
	    			window.location.href='/LinkYourMembershipInterruptView?URL='+urlVal;
	    		}
	    	}else{
	    		if($.trim(urlVal).length !== 0 && urlVal.includes('att.com')){
    				window.location.href=urlRedirection;;
    			} else {
    	    		window.location.href='/LogonForm?URL='+urlVal;
    			}
	    	}
    	}catch(e){
    		window.location.href=urlRedirection;
    	}

    },


    /**
     * This function is used to change Membership and Shop Memberships header
     * links from "/join-costco-quick.html" (used for Quick Purchase flow - when cart is empty)
     * to "/join-costco.html" in case there is something in the cart
     */
    changeLinksForQuickPurchase: function() {
        if($.cookie('cartCountCookie') !== null && $.cookie('cartCountCookie') > 0 ){
        	if($('#Home_Ancillary_7').length >0){
        		$('#Home_Ancillary_7').attr('href', $('#Home_Ancillary_7').attr('href').replace("join-costco-quick.html", "join-costco.html"));
        	}
        	if($('#Home_Ancillary_Popover_7').length >0){
        		$('#Home_Ancillary_Popover_7').text($('#Home_Ancillary_Popover_7').text().replace("join-costco-quick.html", "join-costco.html"));
        	}
        };
    },

    /**
     * This function acts as a listener and replaces the Membership and Shop Memberships header
     * links for quick purchase when Add To Cart is triggered
     */
    replaceShopMembershipLinksOnAddToCart: function () {
        $('body').bind('costco.cart.item.added', function (event) {
           COSTCO.Header.changeLinksForQuickPurchase();
        });
    },

    //Function used to attach the event listener specific to the header dropdowns
    //This is done to work make the dropdowns work the same way as previous popover functionality
    // On Hover/mouseleave the dropdown should toggle
    // On tabout the dropdown should toggle
    // When the dropdown is hidden we should reset the underlying form
    setup_nav_dropdown: function() {

    	$('.header-menu-dropdown').mouseenter(function (event) {
    		//Hover/mouse trigger only for non touch device
    		if(!COSTCO.util.is_touch_device()) {
    			//toggle dropdown if it was not open
    			if(!$(event.target).parents('.dropdown-container').hasClass('open')) {
        			console.log('hover Trigger dropdown');
        			$(this).dropdown('toggle');
        		}
    		}
    	});
    	$('.dropdown-container').on('hide.bs.dropdown',function(e) {
    		//Reset the form inside the dropdown menu on close
    		let dropdownForm =$(e.relatedTarget).siblings('.dropdown-menu').find('form')[0];
    		if(dropdownForm)
    			dropdownForm.reset()
    	})
    	.on('shown.bs.dropdown',function(e) {
    		//On showing the dropdown we need to calculate the offset to center and check if its
    		//within the document width
    		//Current iteration will only handle right overflow
    		let dropdownContainer = $(e.relatedTarget).siblings('.dropdown-menu');
    		let targetPos = $(e.relatedTarget)[0].getBoundingClientRect();
    		let containerWidth = dropdownContainer[0].offsetWidth;

    		let dropdownLeft = targetPos.width / 2 - containerWidth /2;

    		dropdownContainer.css({left: Math.round(dropdownLeft)});
    		//Now that its centered check if new position is over the right edge
    		let windowWidth = $(window).width();
    		let rightEdgeDelta = 0;
    		if(dropdownContainer.offset().left + dropdownContainer.outerWidth() > windowWidth) {
    			rightEdgeDelta = dropdownContainer.offset().left + containerWidth - windowWidth;
    		}
    		dropdownContainer.css({left: Math.round(dropdownLeft - rightEdgeDelta)});

    	});
    	//Kill event propagation if click within the dropdown menu content
    	//if we don't do this it will close the dropdown
    	$('.header-menu-dropdown-content').click(function (event) {
    		event.stopPropagation();
    	})
    	//if user tab out of the menu content close the dropdown
    	.on('mouseleave focusout', function(event){
    		//check if the related target is contained within the content
    		//we allow relatedTarget ==  null with an interesting issue when we click the checkbox it will set
    		//related target to null
    		let relatedTargetContained = event.relatedTarget==null || this.contains(event.relatedTarget);

			if(event.type=='mouseleave' || (event.type=='focusout' && !relatedTargetContained)) {
				//close the dropdown if it was open
				if($(event.target).parent('.dropdown-container').hasClass('open')) {
					$(this).siblings('.header-menu-dropdown').dropdown('toggle');
				}
			}
    	});
    },

    searchFieldValidation: function() {
      $('.CatalogSearchForm').each(function() {
        $(this).validate({
          rules: {
            keyword: 'required',
          },
          messages: {
            keyword: messages.ERR_SEARCHTERM_REQ,
          },
          errorPlacement: function(error, element) {
            element.attr('placeholder', error.text());
          },
        });
      });
    },
    signInOutContainerInit: function() {
    try{
      let c = $.cookie('hashedUserId');
      let kmsiCookie = $.cookie('kmsi');
      $('#myaccount-d').hide();
      if ((c && c != '""') || (kmsiCookie != undefined && kmsiCookie && kmsiCookie != '""' && kmsiCookie != null && kmsiCookie.indexOf('true')>=0)) {
        $('#myaccount-react-d').show();
        $('#header_sign_in').hide();
      } else {
        $('#header_sign_in').show();
        $('#myaccount-react-d').hide();
      }
      try{
	      $('#myaccount-react-d,#myaccount-react-m,#myaccount-react-t').click(function (){

	    	  let queryToMatch = '(min-width: 1025px)';  // 1024px is a tablet

	    	  // This will return a boolean true for desktop and false for tablets and phones.
	    	  if(window.matchMedia(queryToMatch).matches){
		    	  window.wioEventBus.publish('accountMenu', { accountMenu: true });
	    	  }else{
	        	  window.location.href = '/AccountHomeView';
	    	  }
	       });
      }catch(e){

      }
    }catch(e){

    }
    },
    miniShopCartRefresh: function() {
      let c = parseInt($.cookie(cookies.CART_COUNT_COOKIE));
      if ((c && c != '""') || (c == '0')) {
        $('.cart-number').html('<div><span>' + c + '</span></div>');
      }

      var orderTotal = parseFloat($.cookie('wcCartOrder'));

      if (orderTotal && orderTotal!= '""') {
        $('.orderTotal').html(COSTCO.util.isBusinessDelivery() ? COSTCO.util.formatMoney(orderTotal, true) : orderTotal);
      } else {
    	$('.orderTotal').html( COSTCO.util.formatMoney('0.00', true));
      }
      $('.quick-cart-summary').removeClass('hidden');
      /*display order surcharge for BD */
      if (COSTCO.util.isBusinessDelivery())
      {
    	  var total = orderTotal;
    	  if(orderTotal==undefined || isNaN(orderTotal) || orderTotal== '""') {
    		  total = parseFloat("0.0");
    	  }
    	  let currentWhsZipCode = $.cookie('WC_BD_WHS');
    	  let freeDeliveryOrderAmount = currentWhsZipCode === '729' ? parseFloat($('#minimumOrderAmount').val()) : parseFloat($('#freeDeliveryOrderAmount').val());
          let deliverySurcharge = parseFloat($('#deliverySurcharge').val());
          if(typeof checkoutPage != 'undefined' && (checkoutPage == 'shipping' || checkoutPage == 'payment' || checkoutPage == 'review')) {
        	  //no need to invoke ajax from checkout pages like payment, shipping, review
        	  COSTCO.Header.miniBannerRefreshAjax = false;
          }
    	  if(COSTCO.Header.miniBannerRefreshAjax) {
    		  var currentZipCode = $.cookie('WC_BD_ZIP');
    		  var cartTotal = $.cookie('wcCartOrder');
    		  if(cartTotal==undefined || isNaN(cartTotal) || cartTotal== '""') {
    			  cartTotal = parseFloat("0.0");
        	  }
    		  var miniBannerDet = sessionStorage.getItem('miniBannerDetails');
    		  var temp  = miniBannerDet?$.parseJSON(COSTCO.util.decode(miniBannerDet)):null;
	    	  var options = {
					url: '/AjaxGetMiniBannerDetails',
					type: 'POST',
					dataType: 'json',
					data: {
						'orderTotal': total,
						'zipcode': currentZipCode
					},
					success: function(data, textStatus, xhr){
						return data;
					},
					error: function(xhr, textStatus, errorThrown){
						console.log('Error in AjaxGetMiniBannerDetailsCmd');
					}
				};
	    	  var miniBannerData = $.ajax(options)
									.done(function( data ) {
										if (data.errorCode) {
											// session timeout
											if (data.errorCode == 2510) {
												document.location.href = 'Logoff?URL=ReLogonFormView&storeId='+wcs.storeId;
												return;
											}
										  } else {
											COSTCO.Header.refreshMiniBannerDetails(data);
											COSTCO.Header.saveMiniCartDetSessionStorage(data);
										  }
									});

	    	  COSTCO.Header.miniBannerRefreshAjax = false;
    	  } else {
				if ($('#deliverySurcharge').val() !== undefined) {
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
						var isStorePickup = $('#isStorePickupSelected').val() === 'true' ? true : false;
						COSTCO.Header.displayDeliverySurcharge_v2(total, freeDeliveryOrderAmount, deliverySurcharge, isStorePickup);
					} else {
						COSTCO.Header.displayDeliverySurcharge(total, freeDeliveryOrderAmount, deliverySurcharge);
					}
				}
    	  }
      }
    },
    /**
     * Function to display delivery surcharge for BD.
     * @param {number} orderTotal
     * @return {void}
     */
    displayDeliverySurcharge: function(orderTotal, freeDeliveryOrderAmount, deliverySurcharge, isStorePickup) {
      if (typeof checkoutPage != 'undefined' && checkoutPage == 'cart' && COSTCO.util.isNdEnabled() && $('input[name="deliveryMethod"]').length>0) {
    	  var shipmodeId = $('input[name="deliveryMethod"]:checked').val();
    	  var data = {};
    	  if(shipmodeId != undefined){
              if (isStorePickup) {
            	  shipmodeId = shipmodeId + "_SP";
              }
	    	  freeDeliveryOrderAmount = parseFloat($('#freeDeliveeryAmount_'+shipmodeId).val());
	          deliverySurcharge = parseFloat($('#surchargeAmount_'+shipmodeId).val());
	          data.shipmodeId = shipmodeId;
    	  }
          orderTotal = parseFloat($('.orderTotalCart').val());
          data.freeDeliveryOrderAmount = freeDeliveryOrderAmount;
          data.deliverySurcharge = deliverySurcharge;
          data.orderTotal = orderTotal;
          COSTCO.Header.saveMiniCartDetSessionStorage(data);
      }

  	  // Add shipping cost after discount (coming from backend in cookie). (Initially requested for CA only, but then changed for both US and CA STRY0147152)
      // this was for isCABDStore() only then expanded for US too
      // let totalPriceNoDiscountAdded = orderStatic.ordertotal - orderStatic.totaldiscount;
      //  useThisOrderTotal = totalPriceNoDiscountAdded;

      let useThisOrderTotal = orderTotal;

      // Add discount if any to the value coming from cookie to get total value (shipping cost calculated with value before substracting discounts)
      if (typeof orderTotal == "number" && freeDeliveryOrderAmount && deliverySurcharge) {
        if (useThisOrderTotal < freeDeliveryOrderAmount) {
          // Display delivery surcharge
          if (!$('.zero_surcharge_msg').hasClass('hide')) {
            $('.zero_surcharge_msg').addClass('hide');
          }
          if (!$('.zero_surcharge_msg_cart').hasClass('hide')) {
              $('.zero_surcharge_msg_cart').addClass('hide');
            }
          if ($('.surcharge_msg').hasClass('hide')) {
            $('.surcharge_msg').removeClass('hide');
          }
          if (orderTotal > 0) {
            $('.surcharge_bypass_amount').html(COSTCO.util.formatMoney((freeDeliveryOrderAmount - orderTotal).toFixed(2)));
            $('.shipping_charge').html(deliverySurcharge.toFixed(2));
            $('.current-delivery-amount').html(deliverySurcharge.toFixed(2));
            // Correct delivery surcharge order summary section in cart for BD
            if ($('#order-total-estimates') && $('#order-total-estimates').length > 0) {
              $('#order-total-estimates').find('.delivery-surcharge-in-cart').find('.pull-right').html('$' + deliverySurcharge.toFixed(2));
            }
          } else {
            $('#surcharge_bypass_amount').html((freeDeliveryOrderAmount).toFixed(2));
            $('#shipping_charge').html(deliverySurcharge.toFixed(2));
          }
          if (COSTCO.util.isNdEnabled() && $('#order-estimated-total').length > 0 && checkoutPage === 'cart') {
            $('#order-estimated-total').text('$' + (orderTotal+deliverySurcharge).toFixed(2));
            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
              $('#order-estimated-total-mobile').text('$' + (orderTotal+deliverySurcharge).toFixed(2));
            }
          }
        } else {
          // Do not display delivery surcharge
          $('.zero_surcharge_msg').removeClass('hide');
          $('.zero_surcharge_msg_cart').removeClass('hide');
          $('.surcharge_msg').addClass('hide');
          // Correct delivery surcharge order summary section in cart for BD
          if ($('#order-total-estimates') && $('#order-total-estimates').length > 0) {
            $('#order-total-estimates').find('.delivery-surcharge-in-cart').find('.pull-right').html('$0.00');
          }
        }
      } else {
    	  if(COSTCO.util.isNdEnabled() && deliverySurcharge === 0){
    		  $('.zero_surcharge_msg').removeClass('hide');
    		  $('.zero_surcharge_msg_cart').removeClass('hide');
              $('.surcharge_msg').addClass('hide');
              // Correct delivery surcharge order summary section in cart for BD
              if ($('#order-total-estimates') && $('#order-total-estimates').length > 0) {
                $('#order-total-estimates').find('.delivery-surcharge-in-cart').find('.pull-right').html('$0.00');
              }
              if($('#order-estimated-total') && $('#order-estimated-total').length >0 && checkoutPage == 'cart'){
             	 $('#order-estimated-total').text('$' + (orderTotal+deliverySurcharge).toFixed(2));
                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
                  $('#order-estimated-total-mobile').text('$' + (orderTotal+deliverySurcharge).toFixed(2));
                }
              }
    	  }else{
    		  console.error('Invalid values for: orderTotal, freeDeliveryOrderAmount, and/or deliverySurcharge.');
    	  }
      }
    },
    /**
     * Function to display delivery surcharge for BD for website redesign.
     * @param {number} orderTotal
     * @return {void}
     */
    displayDeliverySurcharge_v2: function(orderTotal, freeDeliveryOrderAmount, deliverySurcharge, isStorePickup) {
      if (typeof checkoutPage !== 'undefined' && checkoutPage === 'cart' && COSTCO.util.isNdEnabled() && $('input[name="deliveryMethod"]').length > 0) {
        let shipmodeId = $('#shipmodeIdBD').val().length > 0 ? $('#shipmodeIdBD').val() : $('input[name="deliveryMethod"]:checked').val();
        let data = {};
        if (shipmodeId !== undefined) {
          if (isStorePickup) {
        	  shipmodeId = shipmodeId + "_SP";
          }
          freeDeliveryOrderAmount = parseFloat($('#freeDeliveeryAmount_'+shipmodeId).val());
          deliverySurcharge = parseFloat($('#surchargeAmount_'+shipmodeId).val());
          data.shipmodeId = shipmodeId;
        }
          data.freeDeliveryOrderAmount = freeDeliveryOrderAmount;
          data.deliverySurcharge = deliverySurcharge;
          data.orderTotal = orderTotal;
          COSTCO.Header.saveMiniCartDetSessionStorage(data);
      }
      // Add shipping cost after discount (coming from backend in cookie). (Initially requested for CA only, but then changed for both US and CA STRY0147152)
      // this was for isCABDStore() only then expanded for US too
      // let totalPriceNoDiscountAdded = orderStatic.ordertotal - orderStatic.totaldiscount;
      //  useThisOrderTotal = totalPriceNoDiscountAdded;

      let useThisOrderTotal = orderTotal;
      let cookieDate = $.cookie('deliveryDateCookie');
      let date_str = COSTCO.OrderItems ? COSTCO.OrderItems.getDisplayDateFormatForReview(cookieDate) : cookieDate;
      $('#ship-date-nd-off-display').html(date_str);
      // Add discount if any to the value coming from cookie to get total value (shipping cost calculated with value before substracting discounts)
      if (typeof orderTotal === "number" && freeDeliveryOrderAmount >= 0 && deliverySurcharge >= 0) {

        if (useThisOrderTotal < freeDeliveryOrderAmount) {
          // Display delivery surcharge
          if (!$('.zero_surcharge_msg').hasClass('hide')) {
            $('.zero_surcharge_msg').addClass('hide');
          }
          if (!$('.zero_surcharge_msg_cart').hasClass('hide')) {
              $('.zero_surcharge_msg_cart').addClass('hide');
            }
          if ($('.surcharge_msg').hasClass('hide')) {
            $('.surcharge_msg').removeClass('hide');
          }
          if (orderTotal > 0) {
            $('.surcharge_bypass_amount').html(COSTCO.util.formatMoney((freeDeliveryOrderAmount - orderTotal).toFixed(2)));
            $('.shipping_charge').html(deliverySurcharge.toFixed(2));
            if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
              if (deliverySurcharge.toFixed(0) === "0") {
                $('.delivery-surcharge-nd-off').hide();
                $('.delivery-surcharge-nd-off-waived').show();
              } else {
                $('.delivery-surcharge-nd-off-waived').hide();
                $('.delivery-surcharge-nd-off').show();
              }
            }
            $('.current-delivery-amount').html(deliverySurcharge.toFixed(2));
            // Correct delivery surcharge order summary section in cart for BD
            if ($('#order-summary-total-prices').length > 0) {
              $('#order-summary-total-prices').find('.cart-delivery-surcharge').find('.summary-right').html(COSTCO.util.formatMoney(deliverySurcharge.toFixed(2), true));
            }
          } else {
            $('#surcharge_bypass_amount').html((freeDeliveryOrderAmount).toFixed(2));
            $('#shipping_charge').html(deliverySurcharge.toFixed(2));
            if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
              if (deliverySurcharge.toFixed(0) === "0") {
                $('.delivery-surcharge-nd-off').hide();
                $('.delivery-surcharge-nd-off-waived').show();
              } else {
                $('.delivery-surcharge-nd-off-waived').hide();
                $('.delivery-surcharge-nd-off').show();
              }
            }
          }

          let discount = 0;
          if($('#totalDiscountOutput').attr('discount') != null){
        	  discount = parseFloat($('#totalDiscountOutput').attr('discount'));
          }

          if (COSTCO.util.isNdEnabled() && $('#order-estimated-total').length > 0 && checkoutPage === 'cart') {
            $('#order-estimated-total').text(COSTCO.util.formatMoney((orderTotal+deliverySurcharge).toFixed(2), true));
            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
              $('#order-estimated-total-mobile').text(COSTCO.util.formatMoney((orderTotal+deliverySurcharge).toFixed(2), true));
            }
          }
        } else {
          // Do not display delivery surcharge
          $('.zero_surcharge_msg').removeClass('hide');
          if ($('.delivery-surcharge-nd-off') && $('.delivery-surcharge-nd-off').is(':visible')) {
            $('.delivery-surcharge-nd-off').hide();
            $('.delivery-surcharge-nd-off-waived').show();
          }
          $('.zero_surcharge_msg_cart').removeClass('hide');
          $('.surcharge_msg').addClass('hide');
          // Correct delivery surcharge order summary section in cart for BD
          if ($('#order-summary-total-prices').length > 0) {
            $('#order-summary-total-prices').find('.cart-delivery-surcharge').find('.summary-right').html(COSTCO.util.formatMoney(0, true));
          }
        }
      } else {
        if (COSTCO.util.isNdEnabled() && deliverySurcharge === 0) {
          $('.zero_surcharge_msg').removeClass('hide');
          $('.zero_surcharge_msg_cart').removeClass('hide');
          $('.surcharge_msg').addClass('hide');
          // Correct delivery surcharge order summary section in cart for BD
          if ($('#order-summary-total-prices').length > 0) {
            $('#order-summary-total-prices').find('.cart-delivery-surcharge').find('.summary-right').html(COSTCO.util.formatMoney(0, true));
          }
          if ($('#order-estimated-total').length > 0 && checkoutPage === 'cart') {
            $('#order-estimated-total').text(COSTCO.util.formatMoney((orderTotal+deliverySurcharge).toFixed(2), true));
            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
              $('#order-estimated-total-mobile').text(COSTCO.util.formatMoney((orderTotal+deliverySurcharge).toFixed(2), true));
            }
          }
        } else {
          console.error('Invalid values for: orderTotal, freeDeliveryOrderAmount, and/or deliverySurcharge.');
        }
      }
    },
    displayTooltip:function(shipmodeId, addrType){
        if(typeof(addrType) !== 'undefined') {
        	let currentWhsZipCode = $.cookie('WC_BD_WHS');
        	if(addrType === 'S' || currentWhsZipCode === '729') {
        		let minimumOrderAmount = parseInt($('#minimumOrderAmount').val());
      		  $(".a11y-tooltip").attr("data-content",messages.MINIMUM_ORDER_AMOUNT_TOOLTIP.replace('{0}', minimumOrderAmount));
        	}
        } else if(typeof(shipmodeId) !== 'undefined') {
    		if(shipmodeId == 10101){
    			let surchargeAmount = parseInt($('#freeDeliveryOrderAmount').val());
    			let shippingCharge = parseInt($('#toolTipDeliverySurcharge').val());
    			$('#delivery-fee .a11y-tooltip').attr("data-content",messages.HEADER_BANNER_TOOLTIP.replace('{0}', surchargeAmount).replace('{1}', shippingCharge));
    		}else{
    			$('#delivery-fee .a11y-tooltip').attr("data-content",messages.HEADER_BANNER_TOOLTIP_GND);
    		}
    	}
    },
    /**
     *
     */
    typeahead: function() {
      let search = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: '/TypeAhead?searchTerm=%QUERY&dept=',
          replace: function(url, query) {
          	var serviceURL = '/TypeAhead?searchTerm=%QUERY&dept=';
          	if ($('#grocery-dropdown').text()) {
                	 serviceURL += encodeURIComponent($.trim($('#grocery-dropdown').text()));
            } else {
            	serviceURL += "All";
            }
          	serviceURL += "&storeId=" + wcs.storeId + "&catalogId=" + wcs.catalogId + "&langId=" + wcs.langId;
          	//this param is used by BD to determine whether or not product suggestion should be turned off
          	var isMobile= COSTCO.util.is_touch_device();
          	serviceURL += "&isMobile=" +isMobile;
    	  	let newURL = serviceURL;
    	  	query = encodeURIComponent(query);
            newURL = newURL.replace('%QUERY', query);
            return newURL;
          },
          wildcard: '%QUERY',
          rateLimitWait: 0,
          filter: function(data) {
        	var terms = '';

        		 terms = data.costcoAutoSuggestionView;
            let display = [];
            data = terms || [];
            let count = 0;
            let curObjType = '';
            $.each(data, function(i,obj) {
                if (obj.type != curObjType && count > 0) {
                  obj.border = 'border';
                }
                curObjType = obj.type;
                count++;
                display.push(obj);
              });
            return display;
          },
        },
      });
      $('#search-widget .typeahead').typeahead({
        hint: true,
        highlight: true,
        minLength: parseInt($('#typeAheadMinCharacters').val())
      }, {
        name: 'search',
        display: 'term',
        source: search,
        limit: 999,
        templates: {
          suggestion: function(data) {
            let _in = '<span class="hidden-xs">&nbsp;in&nbsp;</span>';
            let category = data.category ? _in + '<span class="category hidden-xs">' + data.category + '</span>' : '';
            var appType = $('#applicationType').val();
        	if (appType == 'BC'){
             if (data.type == 'Warehouse') {
                let warehouse = '';
                warehouse = ' Warehouse ' + data.properties.WarehouseAddress;
                return '<div class=' + (data.border ? 'border' : '') + '>' + data.value + warehouse + '</div>';
              }
            }
            if (data.type == 'Product') {
                let productImage = '<img class="product-image" src=' + data.properties.FullImage + '>';
                return '<h6 class=' + (data.border ? 'border' : '') + '>' + productImage + data.value + '</h6>';
             }
            return '<div>' + data.term + category + '</div>';
          },
        },
      }).on('typeahead:render', function() {
        // hr element between categories and brands
        if (!$('.tt-dataset :first-child.tt-suggestion').hasClass('border')) {
          $('<hr>').insertBefore($('.tt-dataset .border'));
        }
      }).on('typeahead:selected', function(event, suggestion) {
    	  var appType = $('#applicationType').val();
    	  if (suggestion.refinementId) {
    		  if(suggestion.type == 'Category') {
    			  var searchString = suggestion.identifierId + '.html?'
	    			  + 'autosugg=true';
    			  if($.trim(suggestion.deptId) != '') {
    				  searchString = searchString + '&dept=' + encodeURIComponent(suggestion.deptId)
    			  }
    			  if(window.location.href.includes('warehouse-locations')){
    				  searchString='/'+searchString;
    			  }
    			  window.location.href = searchString;
    		  } else if(suggestion.type == 'ShadowDimension') {
    			  var searchString = suggestion.identifierId + '.html?'
    			  + 'refine=' + suggestion.refinementId +'|';
    			  if($.trim(suggestion.deptId) != '') {
    				  searchString = searchString + '&dept=' + encodeURIComponent(suggestion.deptId)
    			  }
				  if(window.location.href.includes('warehouse-locations')){
    				  searchString='/'+searchString;
    			  }
    			  window.location.href = searchString;
    		  } else if(suggestion.type == 'Warehouse') {
    			  window.location.href = suggestion.baseUrl;
    		  } else if(suggestion.type == 'Product') {
    			  window.location.href = '/'+suggestion.baseUrl.toLowerCase();
    		  } else {
    			  $('.CatalogSearchForm').append('<input type="hidden" name="refine" value=' + suggestion.refinementId + '>');
    			  if($.trim(suggestion.deptId) != '' && suggestion.type != 'Brand' ) {
    				  $('.CatalogSearchForm').append('<input type="hidden" name="dept" value=' + suggestion.deptId + '>');
    			  }
    			  $(this).closest('.CatalogSearchForm').submit();
    		  }
    	  }else{
    		  $(this).closest('.CatalogSearchForm').submit();
    	  }
    	  //if(appType == 'BD' || (appType == 'BC' && suggestion.type != 'Warehouse' && suggestion.type != 'ShadowDimension' && suggestion.type != 'Product'
    		  //&& suggestion.type != 'Category')) {
    		  //$(this).closest('.CatalogSearchForm').submit();
    	  //}
      });
    },
    /**
     * page_size is attached to the onsubmit event handler of the search form.
     * It uses the viewport width to determine the "batch" size of returned results.
     * Where we return 24 for phone resolutions otherwise we return 96.
     * @return {void}
     */
    page_size: function() {
      if (typeof this.pageSize === 'undefined') {
        let pageSize = 96;
        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'pageSize';
        if (window.innerWidth < 668) {
          pageSize = 24;
        }
        input.value = pageSize;
        this.appendChild(input);
      }
    },
    /**
     *Align quick buy buttons in same line.
     * It sets margin-top for button group dynamically.
     * @return {void}
     */
    align_quickbuy_btn: function() {
      let products = $('[data-set-same-height]');

      // Clear margin-top
      products.find('.addbutton').css({
        'padding-top': '0',
      });

      let featureProducts = products.closest('.featured-product');
      let plp = products.closest('.product-list.grid');
      let compare = products.closest('#product-tile-box');

      if (plp && plp.length > 0) {
    	let slickSplits =  products.closest('.slick-list').find('.product-tile-set.slick-slide');
    	if (slickSplits && slickSplits.length > 0) {
    		COSTCO.Header.alignItems(slickSplits);
    	}
        let splits = products.closest('.product-list').find('[data-row-split]:visible');

        if (splits && splits.length > 0) {
          // let rows = []; <- not used
          splits.each(function(index, split) {
            split = $(split);
            let tempProducts = split.prevUntil('[data-row-split]:visible', '.product');
            if (tempProducts && tempProducts.length > 0) {
            	COSTCO.Header.alignItems(tempProducts);
            }
          });
        } else {
        	COSTCO.Header.alignItems(products);
        }
      } else if (($('#isBDAppVar').val() == 'BD' && featureProducts && featureProducts.length > 0)) {
    	  COSTCO.Header.alignItems(featureProducts);
      }else if (($('#isBDAppVar').val() == 'BC' && featureProducts && featureProducts.length > 0) || (compare && compare.length > 0)) {
    	  COSTCO.Header.alignItems(products);
      }
    },

    /**
     * [alignItems description]
     * @param  {[type]} items [description]
     * @return {void}       [description]
     */
    alignItems : function (items) {
      let maxHeight = COSTCO.util.getMaxOutherHeight(items.find('.product-tile-set'));

      items.each(function(index, item) {
        item = $(item);
        let height = item.find('.product-tile-set').height();

        let paddingCorrection = maxHeight - height;
        if(item.find('div.column-stock-status').length >0){
        	let pdbottom = item.find('div.column-stock-status').last().css('padding-bottom');
        	let paddingCorrection_status =  (parseInt(pdbottom,10) || 0 )+ paddingCorrection;
    	item.find('div.column-stock-status').last().css({'padding-bottom': paddingCorrection_status + 'px'});
        }
        else {

        	if(item.find('.addbutton').length > 1 && $('#isBDAppVar').val() == 'BD'){
    			var addbuttonH = item.find('.addbutton').last();
    			var plpSignInForDetails = addbuttonH.find('#plp-sign-in-for-details').css('display');
    			var plpMoreDetails = addbuttonH.find('#plp-more-details').css('display');
    			if(plpSignInForDetails === "none" && plpMoreDetails === "none") {
    				paddingCorrection = paddingCorrection + addbuttonH.height();
    			}
    		}

        	let pdtop =item.find('div.addbutton').css('padding-top');
        	let paddingCorrection_btn = (parseInt(pdtop,10) || 0) + paddingCorrection;
        	if(item.find('.criteo-sponsored').length >0){
        		item.find('div.addbutton').css({'padding-top': paddingCorrection_btn + 'px'});
        	}else{
        		item.find('div.addbutton').css({'padding-top': paddingCorrection_btn + 'px'});
        	}
        }

      });
    },
    /**
     * Assign value to alert-box cookie used to determine whether
     * or not user has closed the alert box before for current warehouse
     * @return {void}
     */
    closeAlertBanner: function(){
      $('#header-promo .alert').on('closed.bs.alert', function () {
        let whsNum;
        if (!!$.cookie('WC_BD_WHS')){
          let whsCookie = $.cookie('WC_BD_WHS').split('-');
          whsNum = whsCookie[0];
        }
        if (!!$.cookie('alert-box')){
          let whsList = $.cookie('alert-box');
          whsList = whsList + '|' + whsNum;
          $.cookie('alert-box', whsList, { path: '/' });
        }else{
          $.cookie('alert-box', whsNum, { path: '/' });
        }
      })
    },

    /**
     * Following function updates all links pointing to the Instacart site
     * zipcode should be appended to any sameday link if the postalcode cookie is present
     * This will prevent the zip code box from opening for new users.
     */
    previousZip : null,
    updateSamedayLinks : function(){

    	var postalCode = $.cookie('invCheckPostalCode')

    	// Exit method if postalCode is not set
    	if(typeof(postalCode) === 'undefined' || postalCode == null || postalCode == ''){
    		return;
    	}
    	//STRY0154556, STRY0154557 - Instacart-canada-phase-2 - Zip code validation for CA site
    	if (COSTCO.util.isCAStore()) {
    		var isValidzipCode = /^\w\d\w.\d\w\d/.test(postalCode);
    		if(!isValidzipCode){
        		return;
        	}
       	}
    	if (COSTCO.util.isUSStore()){
    		var isNumeric = /^\d+$/.test(postalCode);
    		// XSS check
        	if(!isNumeric){
        		return;
        	}

    	}
    	var samedayLinks = $(samedayLink);
    	for(var i=0; i<samedayLinks.length;i++){
    		var link = samedayLinks[i];
    		var href = $(link).attr('href');

    		// Do not append if zipcode is already in the url
    		if(href.indexOf('zipcode=') == -1){
	    		if(href.indexOf('?') > -1){
	    			href = href.concat('&zipcode=' + postalCode);
	    		}else{
	    			href = href.concat('?zipcode=' + postalCode);
	    		}
    		}else{
	    		href = href.replace('zipcode=' + COSTCO.Header.previousZip,'zipcode=' + postalCode);
    		}
    		COSTCO.Header.previousZip = postalCode;
    		$(link).attr('href',href);
    	}

    },

    /**
     * Hide Grocery tile on Banner , when user is on a non-eligible CA grocery region
     * @return {void}
     */
    hideGroceryBannerForInvalidRegion: function(){
    	var isRegionValid=$.cookie('C_2LOC');
    	if(isRegionValid != null && COSTCO.util.isCAStore() && isRegionValid=='false'){
    		//STRY0160243-Flag to disable CA instacart
    		//If instacart CA is enabled , then home ancilalry cannot be hidden based on the 2 day regions alone.
    		//Handled in the espot through branching
    	    if(instaCartCAEnabled=='false'){
	    		//hiding grocery tile for non eligible 2 day regions
	    		$("#Home_Ancillary_0").hide();
    		}
    		//hiding grocery espot "How Costco Grocery Program works" for non eligible 2 day regions
    		$("a[href$='all-costco-grocery.html']").parent().hide();
    	}
    },
    /**
     * Hide Primary Clause when EDD on PDP
     * If the EDD Block exists on the page, then hide the primary clause
     * @return {void}
     */
    hidePrimaryClause: function(){

    	if ($('#edd-form-block').length) {
    		if ($('.primary-clause').length) {
    			$('.primary-clause').hide();
    		}
    	}
    },

    /**
     * bind the refresh button in PDP page
     */
    bindRefreshBtn: function() {
    	if ($("#RefreshBtn").length > 0) {
    		$("#RefreshBtn").click(function(){
    			$("#RefreshBtn").attr("disabled", true);
    			$('#product-page').addClass('ajax-busy');
        		COSTCO.CMath.handleContractSpecificRules();
        	});
          }
    },
    /**
    Function used to attempt set the akamai zipcode,
    * 1. If cookie already exists, remove 'isZipSetByAkamai' from session
    * 2. If cookie doesn't exist try to get the zip code from the Akamai Cookie (client-zip-code)
    */
    setBDZipCodeFromAkamai: function() {
      var currentZipCode = $.cookie('WC_BD_ZIP');
      let akamaiZipEnabled = $('#akamaiZipEnabled').val();
      let customAkamaiZip = $.cookie('client-zip-short');
      let finalZipCode = null;
      let submitZip = function() {
		 if (finalZipCode != null) {
        zipCodeModal.setAkamaiBDZipCode(finalZipCode);
		}
	  if (COSTCO.Header.checkIsForcedSubmitZipcode()) {
		COSTCO.util.removeFromSession('isForcedSubmitZipcode');
	  }
		}
      // Determine if the cookie already exists
      if (!currentZipCode || currentZipCode == '') {
        //if Akamai Zip Enabled in XAPP
        if (akamaiZipEnabled == "1" && customAkamaiZip != null && customAkamaiZip != '' ) {
        //Validate that akamai zip is in the country the store is in
          let postalValidationRegex = null;
          if (COSTCO.util.isCABDStore()) {
            postalValidationRegex = /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}$/;
          } else if (COSTCO.util.isUSBDStore()) {
            postalValidationRegex = /^(\d{5}(-\d{4})?$)$/;
          }
          if (postalValidationRegex.test(customAkamaiZip)) {
            finalZipCode = customAkamaiZip;
            if (COSTCO.util.isCABDStore()) {
				COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie(customAkamaiZip)
					  .then(() => {
						finalZipCode = sessionStorage.getItem('finalZipcode');
						COSTCO.util.removeFromSession('finalZipcode');
						COSTCO.util.setInSession("isGeoApiCalled", true);
						submitZip();
					});
			  } else if (COSTCO.util.isUSBDStore()) {
				finalZipCode = customAkamaiZip;
			  }
            COSTCO.util.setInSession("isZipSetByAkamai", true);
          }
        }
     } else {
       if (COSTCO.Header.checkIsZipSetByAkamai()) {
       //$('#set-zip-code-parent a[open-flyout]').click();
         COSTCO.util.removeFromSession('isZipSetByAkamai');
       }
     }
      if (COSTCO.util.isUSBDStore()) {
			submitZip();
		  }
    },

   refreshMiniBannerDetails: function(data) {
	   if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
		   COSTCO.Header.displayDeliverySurcharge_v2(parseFloat(data.orderTotal),parseFloat(data.freeDeliveryOrderAmount),parseFloat(data.deliverySurcharge), data.isStorePickup);
	   } else {
		   COSTCO.Header.displayDeliverySurcharge(parseFloat(data.orderTotal),parseFloat(data.freeDeliveryOrderAmount),parseFloat(data.deliverySurcharge), data.isStorePickup);
	   }
	   COSTCO.Header.displayTooltip(data.shipmodeId, data.addrType);

	   if($('#set-addr-type-parent').hasClass('hidden')) {
		   $('#set-addr-type-parent').removeClass('hidden');
		   $('#set-addr-type-parent').addClass('visible-xs-block visible-sm-block visible-md-block visible-lg-block visible-xl-block');
	   }

	   if(data.addrType == 'R') {
		   $('#delivery-option-' + data.shipmodeId).prop( "checked", true );
	   } else if (data.addrType == 'S') {
		   $('#delivery-option-SP').prop( "checked", true );
	   } else if (data.addrType == 'C'){
		   $('#delivery-option-10101').prop( "checked", true );
	   }

	   if(!COSTCO.util.isCABDStore()){
		   if(data.addrType == 'R') {
			   $('#bdaddrtype').html('Delivery Method: <span class="bold">Nationwide Delivery</span>');
		   } else if (data.addrType == 'S') {
			   $('#bdaddrtype').html('Delivery Method: <span class="bold">Pick-Up</span>');
		   } else if (data.addrType == 'C'){
			   $('#bdaddrtype').html('Delivery Method: <span class="bold">Local Business Delivery</span>');
		   }
	   }

	   if(!data.showAddrTypeChangeLink) {
		   $('#set-addr-type-change').removeClass('visible-xs-block visible-sm-block visible-md-block visible-lg-block visible-xl-block');
		   $('#set-addr-type-change').addClass('hidden');
	   }

   },
   saveMiniCartDetSessionStorage: function(data) {
	   if(!data.zipDetails) {
		   var bdaddrType = $('#bdaddrtype').text();
		   var addrType = (bdaddrType != '') ? (bdaddrType == 'Commercial Address' ? 'C' : 'R') : '';
		   var currentZipDet = $.cookie('WC_BD_ZIP');
		   if (addrType) {
			   currentZipDet = currentZipDet + "-" + addrType;
		   }
		   data.zipDetails = currentZipDet;
		   data.addrType = addrType;
	   }
	   sessionStorage.setItem('miniBannerDetails', COSTCO.util.encode(JSON.stringify(data)));
   },
   showCommentBox:function(){
		let commentSection = $(COSTCO.util.tmpl('tmpl_return_order_reason_comment'));
       commentSection.find('textarea').focus(function (event) {
         COSTCO.Checkout.character_count('#chars_' + 0, '#comments_' + 0);
       });
       $("#return_edit_form_" + 0).find(".return-comment").remove();
       let actionsContainer = $("#return_actions_" + 0).empty();
       actionsContainer.before(commentSection);
	}
  };

  /*
   *  A11Y STRY0166460
   */
  COSTCO.util.closeDropdownWhenOutOfFocus();

  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.Header = Header;
  return Header;
});



// WEBPACK FOOTER //
// ./js/global/header.js